{
  "main": {
    "fr": {
      "numbers": {
        "defaultNumberingSystem": "latn",
        "otherNumberingSystems": {
          "native": "latn"
        },
        "minimumGroupingDigits": "1",
        "symbols-numberSystem-latn": {
          "decimal": ",",
          "group": " ",
          "list": ";",
          "percentSign": "%",
          "plusSign": "+",
          "minusSign": "-",
          "approximatelySign": "≃",
          "exponential": "E",
          "superscriptingExponent": "×",
          "perMille": "‰",
          "infinity": "∞",
          "nan": "NaN",
          "timeSeparator": ":"
        },
        "decimalFormats-numberSystem-latn": {
          "standard": "#,##0.###",
          "long": {
            "decimalFormat": {
              "1000-count-1": "mille",
              "1000-count-one": "0 millier",
              "1000-count-other": "0 mille",
              "10000-count-one": "00 mille",
              "10000-count-other": "00 mille",
              "100000-count-one": "000 mille",
              "100000-count-other": "000 mille",
              "1000000-count-one": "0 million",
              "1000000-count-other": "0 millions",
              "10000000-count-one": "00 million",
              "10000000-count-other": "00 millions",
              "100000000-count-one": "000 million",
              "100000000-count-other": "000 millions",
              "1000000000-count-one": "0 milliard",
              "1000000000-count-other": "0 milliards",
              "10000000000-count-one": "00 milliard",
              "10000000000-count-other": "00 milliards",
              "100000000000-count-one": "000 milliard",
              "100000000000-count-other": "000 milliards",
              "1000000000000-count-one": "0 billion",
              "1000000000000-count-other": "0 billions",
              "10000000000000-count-one": "00 billion",
              "10000000000000-count-other": "00 billions",
              "100000000000000-count-one": "000 billion",
              "100000000000000-count-other": "000 billions"
            }
          },
          "short": {
            "decimalFormat": {
              "1000-count-one": "0 k",
              "1000-count-other": "0 k",
              "10000-count-one": "00 k",
              "10000-count-other": "00 k",
              "100000-count-one": "000 k",
              "100000-count-other": "000 k",
              "1000000-count-one": "0 M",
              "1000000-count-other": "0 M",
              "10000000-count-one": "00 M",
              "10000000-count-other": "00 M",
              "100000000-count-one": "000 M",
              "100000000-count-other": "000 M",
              "1000000000-count-one": "0 Md",
              "1000000000-count-other": "0 Md",
              "10000000000-count-one": "00 Md",
              "10000000000-count-other": "00 Md",
              "100000000000-count-one": "000 Md",
              "100000000000-count-other": "000 Md",
              "1000000000000-count-one": "0 Bn",
              "1000000000000-count-other": "0 Bn",
              "10000000000000-count-one": "00 Bn",
              "10000000000000-count-other": "00 Bn",
              "100000000000000-count-one": "000 Bn",
              "100000000000000-count-other": "000 Bn"
            }
          }
        },
        "scientificFormats-numberSystem-latn": {
          "standard": "#E0"
        },
        "percentFormats-numberSystem-latn": {
          "standard": "#,##0 %"
        },
        "currencyFormats-numberSystem-latn": {
          "currencySpacing": {
            "beforeCurrency": {
              "currencyMatch": "[[:^S:]&[:^Z:]]",
              "surroundingMatch": "[:digit:]",
              "insertBetween": " "
            },
            "afterCurrency": {
              "currencyMatch": "[[:^S:]&[:^Z:]]",
              "surroundingMatch": "[:digit:]",
              "insertBetween": " "
            }
          },
          "standard": "#,##0.00 ¤",
          "standard-noCurrency": "#,##0.00",
          "accounting": "#,##0.00 ¤;(#,##0.00 ¤)",
          "accounting-noCurrency": "#,##0.00;(#,##0.00)",
          "short": {
            "standard": {
              "1000-count-one": "0 k ¤",
              "1000-count-other": "0 k ¤",
              "10000-count-one": "00 k ¤",
              "10000-count-other": "00 k ¤",
              "100000-count-one": "000 k ¤",
              "100000-count-other": "000 k ¤",
              "1000000-count-one": "0 M ¤",
              "1000000-count-other": "0 M ¤",
              "10000000-count-one": "00 M ¤",
              "10000000-count-other": "00 M ¤",
              "100000000-count-one": "000 M ¤",
              "100000000-count-other": "000 M ¤",
              "1000000000-count-one": "0 Md ¤",
              "1000000000-count-other": "0 Md ¤",
              "10000000000-count-one": "00 Md ¤",
              "10000000000-count-other": "00 Md ¤",
              "100000000000-count-one": "000 Md ¤",
              "100000000000-count-other": "000 Md ¤",
              "1000000000000-count-one": "0 Bn ¤",
              "1000000000000-count-other": "0 Bn ¤",
              "10000000000000-count-one": "00 Bn ¤",
              "10000000000000-count-other": "00 Bn ¤",
              "100000000000000-count-one": "000 Bn ¤",
              "100000000000000-count-other": "000 Bn ¤"
            }
          },
          "currencyPatternAppendISO": "{0} ¤¤",
          "unitPattern-count-one": "{0} {1}",
          "unitPattern-count-other": "{0} {1}"
        },
        "miscPatterns-numberSystem-latn": {
          "approximately": "≈{0}",
          "atLeast": "≥{0}",
          "atMost": "≤{0}",
          "range": "{0}–{1}"
        },
        "minimalPairs": {
          "pluralMinimalPairs-count-one": "{0} jour",
          "pluralMinimalPairs-count-many": "{0} de jours",
          "pluralMinimalPairs-count-other": "{0} jours",
          "one": "Prenez la {0}re à droite.",
          "other": "Prenez la {0}e à droite.",
          "feminine": "La {0} est",
          "masculine": "Le {0} est"
        },
        "currencies": {
          "ADP": {
            "displayName": "peseta andorrane",
            "displayName-count-one": "peseta andorrane",
            "displayName-count-other": "pesetas andorranes"
          },
          "AED": {
            "displayName": "dirham des Émirats arabes unis",
            "displayName-count-one": "dirham des Émirats arabes unis",
            "displayName-count-other": "dirhams des Émirats arabes unis"
          },
          "AFA": {
            "displayName": "afghani (1927–2002)",
            "displayName-count-one": "afghani (1927–2002)",
            "displayName-count-other": "afghanis (1927–2002)"
          },
          "AFN": {
            "displayName": "afghani afghan",
            "displayName-count-one": "afghani afghan",
            "displayName-count-other": "afghanis afghan",
            "symbol-alt-narrow": "؋"
          },
          "ALK": {
            "displayName": "lek albanais (1947–1961)",
            "displayName-count-one": "lek albanais (1947–1961)",
            "displayName-count-other": "leks albanais (1947–1961)"
          },
          "ALL": {
            "displayName": "lek albanais",
            "displayName-count-one": "lek albanais",
            "displayName-count-other": "leks albanais"
          },
          "AMD": {
            "displayName": "dram arménien",
            "displayName-count-one": "dram arménien",
            "displayName-count-other": "drams arméniens",
            "symbol-alt-narrow": "֏"
          },
          "ANG": {
            "displayName": "florin antillais",
            "displayName-count-one": "florin antillais",
            "displayName-count-other": "florins antillais"
          },
          "AOA": {
            "displayName": "kwanza angolais",
            "displayName-count-one": "kwanza angolais",
            "displayName-count-other": "kwanzas angolais",
            "symbol-alt-narrow": "Kz"
          },
          "AOK": {
            "displayName": "kwanza angolais (1977–1990)",
            "displayName-count-one": "kwanza angolais (1977–1990)",
            "displayName-count-other": "kwanzas angolais (1977–1990)"
          },
          "AON": {
            "displayName": "nouveau kwanza angolais (1990–2000)",
            "displayName-count-one": "nouveau kwanza angolais (1990–2000)",
            "displayName-count-other": "nouveaux kwanzas angolais (1990–2000)"
          },
          "AOR": {
            "displayName": "kwanza angolais réajusté (1995–1999)",
            "displayName-count-one": "kwanza angolais réajusté (1995–1999)",
            "displayName-count-other": "kwanzas angolais réajustés (1995–1999)"
          },
          "ARA": {
            "displayName": "austral argentin",
            "displayName-count-one": "austral argentin",
            "displayName-count-other": "australs argentins"
          },
          "ARP": {
            "displayName": "peso argentin (1983–1985)",
            "displayName-count-one": "peso argentin (1983–1985)",
            "displayName-count-other": "pesos argentins (1983–1985)"
          },
          "ARS": {
            "displayName": "peso argentin",
            "displayName-count-one": "peso argentin",
            "displayName-count-other": "pesos argentins",
            "symbol": "$AR",
            "symbol-alt-narrow": "$"
          },
          "ATS": {
            "displayName": "schilling autrichien",
            "displayName-count-one": "schilling autrichien",
            "displayName-count-other": "schillings autrichiens"
          },
          "AUD": {
            "displayName": "dollar australien",
            "displayName-count-one": "dollar australien",
            "displayName-count-other": "dollars australiens",
            "symbol": "$AU",
            "symbol-alt-narrow": "$"
          },
          "AWG": {
            "displayName": "florin arubais",
            "displayName-count-one": "florin arubais",
            "displayName-count-other": "florins arubais"
          },
          "AZM": {
            "displayName": "manat azéri (1993–2006)",
            "displayName-count-one": "manat azéri (1993–2006)",
            "displayName-count-other": "manats azéris (1993–2006)"
          },
          "AZN": {
            "displayName": "manat azéri",
            "displayName-count-one": "manat azéri",
            "displayName-count-other": "manats azéris",
            "symbol-alt-narrow": "₼"
          },
          "BAD": {
            "displayName": "dinar bosniaque",
            "displayName-count-one": "dinar bosniaque",
            "displayName-count-other": "dinars bosniaques"
          },
          "BAM": {
            "displayName": "mark convertible bosniaque",
            "displayName-count-one": "mark convertible bosniaque",
            "displayName-count-other": "marks convertibles bosniaques",
            "symbol-alt-narrow": "KM"
          },
          "BBD": {
            "displayName": "dollar barbadien",
            "displayName-count-one": "dollar barbadien",
            "displayName-count-other": "dollars barbadiens",
            "symbol-alt-narrow": "$"
          },
          "BDT": {
            "displayName": "taka bangladeshi",
            "displayName-count-one": "taka bangladeshi",
            "displayName-count-other": "takas bangladeshis",
            "symbol-alt-narrow": "৳"
          },
          "BEC": {
            "displayName": "franc belge (convertible)",
            "displayName-count-one": "franc belge (convertible)",
            "displayName-count-other": "francs belges (convertibles)"
          },
          "BEF": {
            "displayName": "franc belge",
            "displayName-count-one": "franc belge",
            "displayName-count-other": "francs belges",
            "symbol": "FB"
          },
          "BEL": {
            "displayName": "franc belge (financier)",
            "displayName-count-one": "franc belge (financier)",
            "displayName-count-other": "francs belges (financiers)"
          },
          "BGL": {
            "displayName": "lev bulgare (1962–1999)",
            "displayName-count-one": "lev bulgare (1962–1999)",
            "displayName-count-other": "levs bulgares (1962–1999)"
          },
          "BGN": {
            "displayName": "lev bulgare",
            "displayName-count-one": "lev bulgare",
            "displayName-count-other": "levs bulgares"
          },
          "BHD": {
            "displayName": "dinar bahreïni",
            "displayName-count-one": "dinar bahreïni",
            "displayName-count-other": "dinars bahreïnis"
          },
          "BIF": {
            "displayName": "franc burundais",
            "displayName-count-one": "franc burundais",
            "displayName-count-other": "francs burundais"
          },
          "BMD": {
            "displayName": "dollar bermudien",
            "displayName-count-one": "dollar bermudien",
            "displayName-count-other": "dollars bermudiens",
            "symbol": "$BM",
            "symbol-alt-narrow": "$"
          },
          "BND": {
            "displayName": "dollar brunéien",
            "displayName-count-one": "dollar brunéien",
            "displayName-count-other": "dollars brunéiens",
            "symbol": "$BN",
            "symbol-alt-narrow": "$"
          },
          "BOB": {
            "displayName": "boliviano bolivien",
            "displayName-count-one": "boliviano bolivien",
            "displayName-count-other": "bolivianos boliviens",
            "symbol-alt-narrow": "Bs"
          },
          "BOP": {
            "displayName": "peso bolivien",
            "displayName-count-one": "peso bolivien",
            "displayName-count-other": "pesos boliviens"
          },
          "BOV": {
            "displayName": "mvdol bolivien",
            "displayName-count-one": "mvdol bolivien",
            "displayName-count-other": "mvdols boliviens"
          },
          "BRB": {
            "displayName": "nouveau cruzeiro brésilien (1967–1986)",
            "displayName-count-one": "nouveau cruzeiro brésilien (1967–1986)",
            "displayName-count-other": "nouveaux cruzeiros brésiliens (1967–1986)"
          },
          "BRC": {
            "displayName": "cruzado brésilien (1986–1989)",
            "displayName-count-one": "cruzado brésilien (1986–1989)",
            "displayName-count-other": "cruzados brésiliens (1986–1989)"
          },
          "BRE": {
            "displayName": "cruzeiro brésilien (1990–1993)",
            "displayName-count-one": "cruzeiro brésilien (1990–1993)",
            "displayName-count-other": "cruzeiros brésiliens (1990–1993)"
          },
          "BRL": {
            "displayName": "réal brésilien",
            "displayName-count-one": "réal brésilien",
            "displayName-count-other": "réals brésiliens",
            "symbol": "R$",
            "symbol-alt-narrow": "R$"
          },
          "BRN": {
            "displayName": "nouveau cruzado",
            "displayName-count-one": "nouveau cruzado brésilien (1989–1990)",
            "displayName-count-other": "nouveaux cruzados brésiliens (1989–1990)"
          },
          "BRR": {
            "displayName": "cruzeiro",
            "displayName-count-one": "cruzeiro réal brésilien (1993–1994)",
            "displayName-count-other": "cruzeiros réals brésiliens (1993–1994)"
          },
          "BSD": {
            "displayName": "dollar bahaméen",
            "displayName-count-one": "dollar bahaméen",
            "displayName-count-other": "dollars bahaméens",
            "symbol-alt-narrow": "$"
          },
          "BTN": {
            "displayName": "ngultrum bouthanais",
            "displayName-count-one": "ngultrum bouthanais",
            "displayName-count-other": "ngultrums bouthanais"
          },
          "BUK": {
            "displayName": "kyat birman",
            "displayName-count-one": "kyat birman",
            "displayName-count-other": "kyats birmans"
          },
          "BWP": {
            "displayName": "pula botswanais",
            "displayName-count-one": "pula botswanais",
            "displayName-count-other": "pulas botswanais",
            "symbol-alt-narrow": "P"
          },
          "BYB": {
            "displayName": "nouveau rouble biélorusse (1994–1999)",
            "displayName-count-one": "nouveau rouble biélorusse (1994–1999)",
            "displayName-count-other": "nouveaux roubles biélorusses (1994–1999)"
          },
          "BYN": {
            "displayName": "rouble biélorusse",
            "displayName-count-one": "rouble biélorusse",
            "displayName-count-other": "roubles biélorusses",
            "symbol-alt-narrow": "р."
          },
          "BYR": {
            "displayName": "rouble biélorusse (2000–2016)",
            "displayName-count-one": "rouble biélorusse (2000–2016)",
            "displayName-count-other": "roubles biélorusses (2000–2016)"
          },
          "BZD": {
            "displayName": "dollar bélizéen",
            "displayName-count-one": "dollar bélizéen",
            "displayName-count-other": "dollars bélizéens",
            "symbol": "$BZ",
            "symbol-alt-narrow": "$"
          },
          "CAD": {
            "displayName": "dollar canadien",
            "displayName-count-one": "dollar canadien",
            "displayName-count-other": "dollars canadiens",
            "symbol": "$CA",
            "symbol-alt-narrow": "$"
          },
          "CDF": {
            "displayName": "franc congolais",
            "displayName-count-one": "franc congolais",
            "displayName-count-other": "francs congolais"
          },
          "CHE": {
            "displayName": "euro WIR",
            "displayName-count-one": "euro WIR",
            "displayName-count-other": "euros WIR"
          },
          "CHF": {
            "displayName": "franc suisse",
            "displayName-count-one": "franc suisse",
            "displayName-count-other": "francs suisses"
          },
          "CHW": {
            "displayName": "franc WIR",
            "displayName-count-one": "franc WIR",
            "displayName-count-other": "francs WIR"
          },
          "CLF": {
            "displayName": "unité d’investissement chilienne",
            "displayName-count-one": "unité d’investissement chilienne",
            "displayName-count-other": "unités d’investissement chiliennes"
          },
          "CLP": {
            "displayName": "peso chilien",
            "displayName-count-one": "peso chilien",
            "displayName-count-other": "pesos chiliens",
            "symbol": "$CL",
            "symbol-alt-narrow": "$"
          },
          "CNH": {
            "displayName": "yuan chinois (zone extracôtière)",
            "displayName-count-one": "yuan chinois (zone extracôtière)",
            "displayName-count-other": "yuans chinois (zone extracôtière)"
          },
          "CNY": {
            "displayName": "yuan renminbi chinois",
            "displayName-count-one": "yuan renminbi chinois",
            "displayName-count-other": "yuans renminbi chinois",
            "symbol": "CNY",
            "symbol-alt-narrow": "¥"
          },
          "COP": {
            "displayName": "peso colombien",
            "displayName-count-one": "peso colombien",
            "displayName-count-other": "pesos colombiens",
            "symbol": "$CO",
            "symbol-alt-narrow": "$"
          },
          "COU": {
            "displayName": "unité de valeur réelle colombienne",
            "displayName-count-one": "unité de valeur réelle colombienne",
            "displayName-count-other": "unités de valeur réelle colombiennes"
          },
          "CRC": {
            "displayName": "colón costaricain",
            "displayName-count-one": "colón costaricain",
            "displayName-count-other": "colóns costaricains",
            "symbol-alt-narrow": "₡"
          },
          "CSD": {
            "displayName": "dinar serbo-monténégrin",
            "displayName-count-one": "dinar serbo-monténégrin",
            "displayName-count-other": "dinars serbo-monténégrins"
          },
          "CSK": {
            "displayName": "couronne forte tchécoslovaque",
            "displayName-count-one": "couronne forte tchécoslovaque",
            "displayName-count-other": "couronnes fortes tchécoslovaques"
          },
          "CUC": {
            "displayName": "peso cubain convertible",
            "displayName-count-one": "peso cubain convertible",
            "displayName-count-other": "pesos cubains convertibles",
            "symbol-alt-narrow": "$"
          },
          "CUP": {
            "displayName": "peso cubain",
            "displayName-count-one": "peso cubain",
            "displayName-count-other": "pesos cubains",
            "symbol-alt-narrow": "$"
          },
          "CVE": {
            "displayName": "escudo capverdien",
            "displayName-count-one": "escudo capverdien",
            "displayName-count-other": "escudos capverdiens"
          },
          "CYP": {
            "displayName": "livre chypriote",
            "displayName-count-one": "livre chypriote",
            "displayName-count-other": "livres chypriotes",
            "symbol": "£CY"
          },
          "CZK": {
            "displayName": "couronne tchèque",
            "displayName-count-one": "couronne tchèque",
            "displayName-count-other": "couronnes tchèques",
            "symbol-alt-narrow": "Kč"
          },
          "DDM": {
            "displayName": "mark est-allemand",
            "displayName-count-one": "mark est-allemand",
            "displayName-count-other": "marks est-allemands"
          },
          "DEM": {
            "displayName": "mark allemand",
            "displayName-count-one": "mark allemand",
            "displayName-count-other": "marks allemands"
          },
          "DJF": {
            "displayName": "franc djiboutien",
            "displayName-count-one": "franc djiboutien",
            "displayName-count-other": "francs djiboutiens"
          },
          "DKK": {
            "displayName": "couronne danoise",
            "displayName-count-one": "couronne danoise",
            "displayName-count-other": "couronnes danoises",
            "symbol-alt-narrow": "kr"
          },
          "DOP": {
            "displayName": "peso dominicain",
            "displayName-count-one": "peso dominicain",
            "displayName-count-other": "pesos dominicains",
            "symbol-alt-narrow": "$"
          },
          "DZD": {
            "displayName": "dinar algérien",
            "displayName-count-one": "dinar algérien",
            "displayName-count-other": "dinars algériens"
          },
          "ECS": {
            "displayName": "sucre équatorien",
            "displayName-count-one": "sucre équatorien",
            "displayName-count-other": "sucres équatoriens"
          },
          "ECV": {
            "displayName": "unité de valeur constante équatoriale (UVC)",
            "displayName-count-one": "unité de valeur constante équatorienne (UVC)",
            "displayName-count-other": "unités de valeur constante équatoriennes (UVC)"
          },
          "EEK": {
            "displayName": "couronne estonienne",
            "displayName-count-one": "couronne estonienne",
            "displayName-count-other": "couronnes estoniennes"
          },
          "EGP": {
            "displayName": "livre égyptienne",
            "displayName-count-one": "livre égyptienne",
            "displayName-count-other": "livres égyptiennes",
            "symbol-alt-narrow": "£E"
          },
          "ERN": {
            "displayName": "nafka érythréen",
            "displayName-count-one": "nafka érythréen",
            "displayName-count-other": "nafkas érythréens"
          },
          "ESA": {
            "displayName": "peseta espagnole (compte A)",
            "displayName-count-one": "peseta espagnole (compte A)",
            "displayName-count-other": "pesetas espagnoles (compte A)"
          },
          "ESB": {
            "displayName": "peseta espagnole (compte convertible)",
            "displayName-count-one": "peseta espagnole (compte convertible)",
            "displayName-count-other": "pesetas espagnoles (compte convertible)"
          },
          "ESP": {
            "displayName": "peseta espagnole",
            "displayName-count-one": "peseta espagnole",
            "displayName-count-other": "pesetas espagnoles",
            "symbol-alt-narrow": "₧"
          },
          "ETB": {
            "displayName": "birr éthiopien",
            "displayName-count-one": "birr éthiopien",
            "displayName-count-other": "birrs éthiopiens"
          },
          "EUR": {
            "displayName": "euro",
            "displayName-count-one": "euro",
            "displayName-count-other": "euros",
            "symbol": "€",
            "symbol-alt-narrow": "€"
          },
          "FIM": {
            "displayName": "mark finlandais",
            "displayName-count-one": "mark finlandais",
            "displayName-count-other": "marks finlandais"
          },
          "FJD": {
            "displayName": "dollar fidjien",
            "displayName-count-one": "dollar fidjien",
            "displayName-count-other": "dollars fidjiens",
            "symbol": "$FJ",
            "symbol-alt-narrow": "$"
          },
          "FKP": {
            "displayName": "livre des îles Malouines",
            "displayName-count-one": "livre des îles Malouines",
            "displayName-count-other": "livres des îles Malouines",
            "symbol": "£FK",
            "symbol-alt-narrow": "£"
          },
          "FRF": {
            "displayName": "franc français",
            "displayName-count-one": "franc français",
            "displayName-count-other": "francs français",
            "symbol": "F"
          },
          "GBP": {
            "displayName": "livre sterling",
            "displayName-count-one": "livre sterling",
            "displayName-count-other": "livres sterling",
            "symbol": "£GB",
            "symbol-alt-narrow": "£"
          },
          "GEK": {
            "displayName": "coupon de lari géorgien",
            "displayName-count-one": "coupon de lari géorgien",
            "displayName-count-other": "coupons de lari géorgiens"
          },
          "GEL": {
            "displayName": "lari géorgien",
            "displayName-count-one": "lari géorgien",
            "displayName-count-other": "lari géorgiens",
            "symbol-alt-narrow": "₾"
          },
          "GHC": {
            "displayName": "cédi",
            "displayName-count-one": "cédi ghanéen (1967–2007)",
            "displayName-count-other": "cédis ghanéens (1967–2007)"
          },
          "GHS": {
            "displayName": "cédi ghanéen",
            "displayName-count-one": "cédi ghanéen",
            "displayName-count-other": "cédis ghanéens",
            "symbol-alt-narrow": "GH₵"
          },
          "GIP": {
            "displayName": "livre de Gibraltar",
            "displayName-count-one": "livre de Gibraltar",
            "displayName-count-other": "livres de Gibraltar",
            "symbol": "£GI",
            "symbol-alt-narrow": "£"
          },
          "GMD": {
            "displayName": "dalasi gambien",
            "displayName-count-one": "dalasi gambien",
            "displayName-count-other": "dalasis gambiens"
          },
          "GNF": {
            "displayName": "franc guinéen",
            "displayName-count-one": "franc guinéen",
            "displayName-count-other": "francs guinéens",
            "symbol-alt-narrow": "FG"
          },
          "GNS": {
            "displayName": "syli guinéen",
            "displayName-count-one": "syli guinéen",
            "displayName-count-other": "sylis guinéens"
          },
          "GQE": {
            "displayName": "ekwélé équatoguinéen",
            "displayName-count-one": "ekwélé équatoguinéen",
            "displayName-count-other": "ekwélés équatoguinéens"
          },
          "GRD": {
            "displayName": "drachme grecque",
            "displayName-count-one": "drachme grecque",
            "displayName-count-other": "drachmes grecques"
          },
          "GTQ": {
            "displayName": "quetzal guatémaltèque",
            "displayName-count-one": "quetzal guatémaltèque",
            "displayName-count-other": "quetzals guatémaltèques",
            "symbol-alt-narrow": "Q"
          },
          "GWE": {
            "displayName": "escudo de Guinée portugaise",
            "displayName-count-one": "escudo de Guinée portugaise",
            "displayName-count-other": "escudos de Guinée portugaise"
          },
          "GWP": {
            "displayName": "peso bissau-guinéen",
            "displayName-count-one": "peso bissau-guinéen",
            "displayName-count-other": "pesos bissau-guinéens"
          },
          "GYD": {
            "displayName": "dollar du Guyana",
            "displayName-count-one": "dollar du Guyana",
            "displayName-count-other": "dollars du Guyana",
            "symbol-alt-narrow": "$"
          },
          "HKD": {
            "displayName": "dollar de Hong Kong",
            "displayName-count-one": "dollar de Hong Kong",
            "displayName-count-other": "dollars de Hong Kong",
            "symbol": "HKD",
            "symbol-alt-narrow": "$"
          },
          "HNL": {
            "displayName": "lempira hondurien",
            "displayName-count-one": "lempira hondurien",
            "displayName-count-other": "lempiras honduriens",
            "symbol-alt-narrow": "L"
          },
          "HRD": {
            "displayName": "dinar croate",
            "displayName-count-one": "dinar croate",
            "displayName-count-other": "dinars croates"
          },
          "HRK": {
            "displayName": "kuna croate",
            "displayName-count-one": "kuna croate",
            "displayName-count-other": "kunas croates",
            "symbol-alt-narrow": "kn"
          },
          "HTG": {
            "displayName": "gourde haïtienne",
            "displayName-count-one": "gourde haïtienne",
            "displayName-count-other": "gourdes haïtiennes"
          },
          "HUF": {
            "displayName": "forint hongrois",
            "displayName-count-one": "forint hongrois",
            "displayName-count-other": "forints hongrois",
            "symbol-alt-narrow": "Ft"
          },
          "IDR": {
            "displayName": "roupie indonésienne",
            "displayName-count-one": "roupie indonésienne",
            "displayName-count-other": "roupies indonésiennes",
            "symbol-alt-narrow": "Rp"
          },
          "IEP": {
            "displayName": "livre irlandaise",
            "displayName-count-one": "livre irlandaise",
            "displayName-count-other": "livres irlandaises",
            "symbol": "£IE"
          },
          "ILP": {
            "displayName": "livre israélienne",
            "displayName-count-one": "livre israélienne",
            "displayName-count-other": "livres israéliennes",
            "symbol": "£IL"
          },
          "ILS": {
            "displayName": "nouveau shekel israélien",
            "displayName-count-one": "nouveau shekel israélien",
            "displayName-count-other": "nouveaux shekels israéliens",
            "symbol": "₪",
            "symbol-alt-narrow": "₪"
          },
          "INR": {
            "displayName": "roupie indienne",
            "displayName-count-one": "roupie indienne",
            "displayName-count-other": "roupies indiennes",
            "symbol": "₹",
            "symbol-alt-narrow": "₹"
          },
          "IQD": {
            "displayName": "dinar irakien",
            "displayName-count-one": "dinar irakien",
            "displayName-count-other": "dinars irakiens"
          },
          "IRR": {
            "displayName": "riyal iranien",
            "displayName-count-one": "riyal iranien",
            "displayName-count-other": "riyals iraniens"
          },
          "ISK": {
            "displayName": "couronne islandaise",
            "displayName-count-one": "couronne islandaise",
            "displayName-count-other": "couronnes islandaises",
            "symbol-alt-narrow": "kr"
          },
          "ITL": {
            "displayName": "lire italienne",
            "displayName-count-one": "lire italienne",
            "displayName-count-other": "lires italiennes",
            "symbol": "₤IT"
          },
          "JMD": {
            "displayName": "dollar jamaïcain",
            "displayName-count-one": "dollar jamaïcain",
            "displayName-count-other": "dollars jamaïcains",
            "symbol-alt-narrow": "$"
          },
          "JOD": {
            "displayName": "dinar jordanien",
            "displayName-count-one": "dinar jordanien",
            "displayName-count-other": "dinars jordaniens"
          },
          "JPY": {
            "displayName": "yen japonais",
            "displayName-count-one": "yen japonais",
            "displayName-count-other": "yens japonais",
            "symbol": "JPY",
            "symbol-alt-narrow": "¥"
          },
          "KES": {
            "displayName": "shilling kényan",
            "displayName-count-one": "shilling kényan",
            "displayName-count-other": "shillings kényans"
          },
          "KGS": {
            "displayName": "som kirghize",
            "displayName-count-one": "som kirghize",
            "displayName-count-other": "soms kirghizes",
            "symbol-alt-narrow": "⃀"
          },
          "KHR": {
            "displayName": "riel cambodgien",
            "displayName-count-one": "riel cambodgien",
            "displayName-count-other": "riels cambodgiens",
            "symbol-alt-narrow": "៛"
          },
          "KMF": {
            "displayName": "franc comorien",
            "displayName-count-one": "franc comorien",
            "displayName-count-other": "francs comoriens",
            "symbol-alt-narrow": "FC"
          },
          "KPW": {
            "displayName": "won nord-coréen",
            "displayName-count-one": "won nord-coréen",
            "displayName-count-other": "wons nord-coréens",
            "symbol-alt-narrow": "₩"
          },
          "KRW": {
            "displayName": "won sud-coréen",
            "displayName-count-one": "won sud-coréen",
            "displayName-count-other": "wons sud-coréens",
            "symbol": "₩",
            "symbol-alt-narrow": "₩"
          },
          "KWD": {
            "displayName": "dinar koweïtien",
            "displayName-count-one": "dinar koweïtien",
            "displayName-count-other": "dinar koweïtiens"
          },
          "KYD": {
            "displayName": "dollar des îles Caïmans",
            "displayName-count-one": "dollar des îles Caïmans",
            "displayName-count-other": "dollars des îles Caïmans",
            "symbol-alt-narrow": "$"
          },
          "KZT": {
            "displayName": "tenge kazakh",
            "displayName-count-one": "tenge kazakh",
            "displayName-count-other": "tenges kazakhs",
            "symbol-alt-narrow": "₸"
          },
          "LAK": {
            "displayName": "kip laotien",
            "displayName-count-one": "kip laotien",
            "displayName-count-other": "kips laotiens",
            "symbol-alt-narrow": "₭"
          },
          "LBP": {
            "displayName": "livre libanaise",
            "displayName-count-one": "livre libanaise",
            "displayName-count-other": "livres libanaises",
            "symbol": "£LB",
            "symbol-alt-narrow": "£L"
          },
          "LKR": {
            "displayName": "roupie srilankaise",
            "displayName-count-one": "roupie srilankaise",
            "displayName-count-other": "roupies srilankaises",
            "symbol-alt-narrow": "Rs"
          },
          "LRD": {
            "displayName": "dollar libérien",
            "displayName-count-one": "dollar libérien",
            "displayName-count-other": "dollars libériens",
            "symbol-alt-narrow": "$"
          },
          "LSL": {
            "displayName": "loti lesothan",
            "displayName-count-one": "loti lesothan",
            "displayName-count-other": "maloti lesothans"
          },
          "LTL": {
            "displayName": "litas lituanien",
            "displayName-count-one": "litas lituanien",
            "displayName-count-other": "litas lituaniens",
            "symbol-alt-narrow": "Lt"
          },
          "LTT": {
            "displayName": "talonas lituanien",
            "displayName-count-one": "talonas lituanien",
            "displayName-count-other": "talonas lituaniens"
          },
          "LUC": {
            "displayName": "franc convertible luxembourgeois",
            "displayName-count-one": "franc convertible luxembourgeois",
            "displayName-count-other": "francs convertibles luxembourgeois"
          },
          "LUF": {
            "displayName": "franc luxembourgeois",
            "displayName-count-one": "franc luxembourgeois",
            "displayName-count-other": "francs luxembourgeois"
          },
          "LUL": {
            "displayName": "franc financier luxembourgeois",
            "displayName-count-one": "franc financier luxembourgeois",
            "displayName-count-other": "francs financiers luxembourgeois"
          },
          "LVL": {
            "displayName": "lats letton",
            "displayName-count-one": "lats letton",
            "displayName-count-other": "lats lettons",
            "symbol-alt-narrow": "Ls"
          },
          "LVR": {
            "displayName": "rouble letton",
            "displayName-count-one": "rouble letton",
            "displayName-count-other": "roubles lettons"
          },
          "LYD": {
            "displayName": "dinar libyen",
            "displayName-count-one": "dinar libyen",
            "displayName-count-other": "dinars libyens"
          },
          "MAD": {
            "displayName": "dirham marocain",
            "displayName-count-one": "dirham marocain",
            "displayName-count-other": "dirhams marocains"
          },
          "MAF": {
            "displayName": "franc marocain",
            "displayName-count-one": "franc marocain",
            "displayName-count-other": "francs marocains"
          },
          "MDL": {
            "displayName": "leu moldave",
            "displayName-count-one": "leu moldave",
            "displayName-count-other": "leus moldaves"
          },
          "MGA": {
            "displayName": "ariary malgache",
            "displayName-count-one": "ariary malgache",
            "displayName-count-other": "ariarys malgaches",
            "symbol-alt-narrow": "Ar"
          },
          "MGF": {
            "displayName": "franc malgache",
            "displayName-count-one": "franc malgache",
            "displayName-count-other": "francs malgaches"
          },
          "MKD": {
            "displayName": "denar macédonien",
            "displayName-count-one": "denar macédonien",
            "displayName-count-other": "denars macédoniens"
          },
          "MLF": {
            "displayName": "franc malien",
            "displayName-count-one": "franc malien",
            "displayName-count-other": "francs maliens"
          },
          "MMK": {
            "displayName": "kyat myanmarais",
            "displayName-count-one": "kyat myanmarais",
            "displayName-count-other": "kyats myanmarais",
            "symbol-alt-narrow": "K"
          },
          "MNT": {
            "displayName": "tugrik mongol",
            "displayName-count-one": "tugrik mongol",
            "displayName-count-other": "tugriks mongols",
            "symbol-alt-narrow": "₮"
          },
          "MOP": {
            "displayName": "pataca macanaise",
            "displayName-count-one": "pataca macanaise",
            "displayName-count-other": "patacas macanaises"
          },
          "MRO": {
            "displayName": "ouguiya mauritanien (1973–2017)",
            "displayName-count-one": "ouguiya mauritanien (1973–2017)",
            "displayName-count-other": "ouguiyas mauritaniens (1973–2017)"
          },
          "MRU": {
            "displayName": "ouguiya mauritanien",
            "displayName-count-one": "ouguiya mauritanien",
            "displayName-count-other": "ouguiyas mauritaniens"
          },
          "MTL": {
            "displayName": "lire maltaise",
            "displayName-count-one": "lire maltaise",
            "displayName-count-other": "lires maltaises"
          },
          "MTP": {
            "displayName": "livre maltaise",
            "displayName-count-one": "livre maltaise",
            "displayName-count-other": "livres maltaises",
            "symbol": "£MT"
          },
          "MUR": {
            "displayName": "roupie mauricienne",
            "displayName-count-one": "roupie mauricienne",
            "displayName-count-other": "roupies mauriciennes",
            "symbol-alt-narrow": "Rs"
          },
          "MVR": {
            "displayName": "rufiyaa maldivienne",
            "displayName-count-one": "rufiyaa maldivienne",
            "displayName-count-other": "rufiyaas maldiviennes"
          },
          "MWK": {
            "displayName": "kwacha malawite",
            "displayName-count-one": "kwacha malawite",
            "displayName-count-other": "kwachas malawites"
          },
          "MXN": {
            "displayName": "peso mexicain",
            "displayName-count-one": "peso mexicain",
            "displayName-count-other": "pesos mexicains",
            "symbol": "$MX",
            "symbol-alt-narrow": "$"
          },
          "MXP": {
            "displayName": "peso d’argent mexicain (1861–1992)",
            "displayName-count-one": "peso d’argent mexicain (1861–1992)",
            "displayName-count-other": "pesos d’argent mexicains (1861–1992)"
          },
          "MXV": {
            "displayName": "unité de conversion mexicaine (UDI)",
            "displayName-count-one": "unité de conversion mexicaine (UDI)",
            "displayName-count-other": "unités de conversion mexicaines (UDI)"
          },
          "MYR": {
            "displayName": "ringgit malais",
            "displayName-count-one": "ringgit malais",
            "displayName-count-other": "ringgits malais",
            "symbol-alt-narrow": "RM"
          },
          "MZE": {
            "displayName": "escudo mozambicain",
            "displayName-count-one": "escudo mozambicain",
            "displayName-count-other": "escudos mozambicains"
          },
          "MZM": {
            "displayName": "métical",
            "displayName-count-one": "metical mozambicain (1980–2006)",
            "displayName-count-other": "meticais mozambicains (1980–2006)"
          },
          "MZN": {
            "displayName": "metical mozambicain",
            "displayName-count-one": "metical mozambicain",
            "displayName-count-other": "meticais mozambicains"
          },
          "NAD": {
            "displayName": "dollar namibien",
            "displayName-count-one": "dollar namibien",
            "displayName-count-other": "dollars namibiens",
            "symbol": "$NA",
            "symbol-alt-narrow": "$"
          },
          "NGN": {
            "displayName": "naira nigérian",
            "displayName-count-one": "naira nigérian",
            "displayName-count-other": "nairas nigérians",
            "symbol-alt-narrow": "₦"
          },
          "NIC": {
            "displayName": "cordoba",
            "displayName-count-one": "córdoba nicaraguayen (1912–1988)",
            "displayName-count-other": "córdobas nicaraguayens (1912–1988)"
          },
          "NIO": {
            "displayName": "córdoba oro nicaraguayen",
            "displayName-count-one": "córdoba oro nicaraguayen",
            "displayName-count-other": "córdobas oro nicaraguayens",
            "symbol-alt-narrow": "$C"
          },
          "NLG": {
            "displayName": "florin néerlandais",
            "displayName-count-one": "florin néerlandais",
            "displayName-count-other": "florins néerlandais"
          },
          "NOK": {
            "displayName": "couronne norvégienne",
            "displayName-count-one": "couronne norvégienne",
            "displayName-count-other": "couronnes norvégiennes",
            "symbol-alt-narrow": "kr"
          },
          "NPR": {
            "displayName": "roupie népalaise",
            "displayName-count-one": "roupie népalaise",
            "displayName-count-other": "roupies népalaises",
            "symbol-alt-narrow": "Rs"
          },
          "NZD": {
            "displayName": "dollar néo-zélandais",
            "displayName-count-one": "dollar néo-zélandais",
            "displayName-count-other": "dollars néo-zélandais",
            "symbol": "$NZ",
            "symbol-alt-narrow": "$"
          },
          "OMR": {
            "displayName": "riyal omanais",
            "displayName-count-one": "riyal omanais",
            "displayName-count-other": "riyals omanis"
          },
          "PAB": {
            "displayName": "balboa panaméen",
            "displayName-count-one": "balboa panaméen",
            "displayName-count-other": "balboas panaméens"
          },
          "PEI": {
            "displayName": "inti péruvien",
            "displayName-count-one": "inti péruvien",
            "displayName-count-other": "intis péruviens"
          },
          "PEN": {
            "displayName": "sol péruvien",
            "displayName-count-one": "sol péruvien",
            "displayName-count-other": "sols péruviens"
          },
          "PES": {
            "displayName": "sol péruvien (1863–1985)",
            "displayName-count-one": "sol péruvien (1863–1985)",
            "displayName-count-other": "sols péruviens (1863–1985)"
          },
          "PGK": {
            "displayName": "kina papouan-néo-guinéen",
            "displayName-count-one": "kina papouan-néo-guinéen",
            "displayName-count-other": "kinas papouan-néo-guinéens"
          },
          "PHP": {
            "displayName": "peso philippin",
            "displayName-count-one": "peso philippin",
            "displayName-count-other": "pesos philippins",
            "symbol": "PHP",
            "symbol-alt-narrow": "₱"
          },
          "PKR": {
            "displayName": "roupie pakistanaise",
            "displayName-count-one": "roupie pakistanaise",
            "displayName-count-other": "roupies pakistanaises",
            "symbol-alt-narrow": "Rs"
          },
          "PLN": {
            "displayName": "zloty polonais",
            "displayName-count-one": "zloty polonais",
            "displayName-count-other": "zlotys polonais",
            "symbol-alt-narrow": "zł"
          },
          "PLZ": {
            "displayName": "zloty (1950–1995)",
            "displayName-count-one": "zloty polonais (1950–1995)",
            "displayName-count-other": "zlotys polonais (1950–1995)"
          },
          "PTE": {
            "displayName": "escudo portugais",
            "displayName-count-one": "escudo portugais",
            "displayName-count-other": "escudos portugais"
          },
          "PYG": {
            "displayName": "guaraní paraguayen",
            "displayName-count-one": "guaraní paraguayen",
            "displayName-count-other": "guaranís paraguayens",
            "symbol-alt-narrow": "₲"
          },
          "QAR": {
            "displayName": "riyal qatari",
            "displayName-count-one": "riyal qatari",
            "displayName-count-other": "riyals qataris"
          },
          "RHD": {
            "displayName": "dollar rhodésien",
            "displayName-count-one": "dollar rhodésien",
            "displayName-count-other": "dollars rhodésiens",
            "symbol": "$RH"
          },
          "ROL": {
            "displayName": "ancien leu roumain",
            "displayName-count-one": "leu roumain (1952–2005)",
            "displayName-count-other": "lei roumains (1952–2005)"
          },
          "RON": {
            "displayName": "leu roumain",
            "displayName-count-one": "leu roumain",
            "displayName-count-other": "lei roumains",
            "symbol-alt-narrow": "L"
          },
          "RSD": {
            "displayName": "dinar serbe",
            "displayName-count-one": "dinar serbe",
            "displayName-count-other": "dinars serbes"
          },
          "RUB": {
            "displayName": "rouble russe",
            "displayName-count-one": "rouble russe",
            "displayName-count-other": "roubles russes",
            "symbol-alt-narrow": "₽"
          },
          "RUR": {
            "displayName": "rouble russe (1991–1998)",
            "displayName-count-one": "rouble russe (1991–1998)",
            "displayName-count-other": "roubles russes (1991–1998)"
          },
          "RWF": {
            "displayName": "franc rwandais",
            "displayName-count-one": "franc rwandais",
            "displayName-count-other": "francs rwandais",
            "symbol-alt-narrow": "FR"
          },
          "SAR": {
            "displayName": "riyal saoudien",
            "displayName-count-one": "riyal saoudien",
            "displayName-count-other": "riyals saoudiens"
          },
          "SBD": {
            "displayName": "dollar des îles Salomon",
            "displayName-count-one": "dollar des îles Salomon",
            "displayName-count-other": "dollars des îles Salomon",
            "symbol": "$SB",
            "symbol-alt-narrow": "$"
          },
          "SCR": {
            "displayName": "roupie des Seychelles",
            "displayName-count-one": "roupie des Seychelles",
            "displayName-count-other": "roupies des Seychelles"
          },
          "SDD": {
            "displayName": "dinar soudanais",
            "displayName-count-one": "dinar soudanais (1992–2007)",
            "displayName-count-other": "dinars soudanais (1992–2007)"
          },
          "SDG": {
            "displayName": "livre soudanaise",
            "displayName-count-one": "livre soudanaise",
            "displayName-count-other": "livres soudanaises"
          },
          "SDP": {
            "displayName": "livre soudanaise (1956–2007)",
            "displayName-count-one": "livre soudanaise (1956–2007)",
            "displayName-count-other": "livres soudanaises (1956–2007)"
          },
          "SEK": {
            "displayName": "couronne suédoise",
            "displayName-count-one": "couronne suédoise",
            "displayName-count-other": "couronnes suédoises",
            "symbol-alt-narrow": "kr"
          },
          "SGD": {
            "displayName": "dollar de Singapour",
            "displayName-count-one": "dollar de Singapour",
            "displayName-count-other": "dollars de Singapour",
            "symbol": "$SG",
            "symbol-alt-narrow": "$"
          },
          "SHP": {
            "displayName": "livre de Sainte-Hélène",
            "displayName-count-one": "livre de Sainte-Hélène",
            "displayName-count-other": "livres de Sainte-Hélène",
            "symbol-alt-narrow": "£"
          },
          "SIT": {
            "displayName": "tolar slovène",
            "displayName-count-one": "tolar slovène",
            "displayName-count-other": "tolars slovènes"
          },
          "SKK": {
            "displayName": "couronne slovaque",
            "displayName-count-one": "couronne slovaque",
            "displayName-count-other": "couronnes slovaques"
          },
          "SLE": {
            "displayName": "leone sierra-léonais",
            "displayName-count-one": "leone sierra-léonais",
            "displayName-count-other": "leones sierra-léonais"
          },
          "SLL": {
            "displayName": "leone sierra-léonais (1964—2022)",
            "displayName-count-one": "leone sierra-léonais (1964—2022)",
            "displayName-count-other": "leones sierra-léonais (1964—2022)"
          },
          "SOS": {
            "displayName": "shilling somalien",
            "displayName-count-one": "shilling somalien",
            "displayName-count-other": "shillings somaliens"
          },
          "SRD": {
            "displayName": "dollar surinamais",
            "displayName-count-one": "dollar surinamais",
            "displayName-count-other": "dollars surinamais",
            "symbol": "$SR",
            "symbol-alt-narrow": "$"
          },
          "SRG": {
            "displayName": "florin surinamais",
            "displayName-count-one": "florin surinamais",
            "displayName-count-other": "florins surinamais"
          },
          "SSP": {
            "displayName": "livre sud-soudanaise",
            "displayName-count-one": "livre sud-soudanaise",
            "displayName-count-other": "livres sud-soudanaises",
            "symbol-alt-narrow": "£"
          },
          "STD": {
            "displayName": "dobra santoméen (1977–2017)",
            "displayName-count-one": "dobra santoméen (1977–2017)",
            "displayName-count-other": "dobras santoméens (1977–2017)"
          },
          "STN": {
            "displayName": "dobra santoméen",
            "displayName-count-one": "dobra santoméen",
            "displayName-count-other": "dobras santoméens",
            "symbol-alt-narrow": "Db"
          },
          "SUR": {
            "displayName": "rouble soviétique",
            "displayName-count-one": "rouble soviétique",
            "displayName-count-other": "roubles soviétiques"
          },
          "SVC": {
            "displayName": "colón salvadorien",
            "displayName-count-one": "colón salvadorien",
            "displayName-count-other": "colóns salvadoriens"
          },
          "SYP": {
            "displayName": "livre syrienne",
            "displayName-count-one": "livre syrienne",
            "displayName-count-other": "livres syriennes",
            "symbol-alt-narrow": "£"
          },
          "SZL": {
            "displayName": "lilangeni swazi",
            "displayName-count-one": "lilangeni swazi",
            "displayName-count-other": "lilangenis swazis"
          },
          "THB": {
            "displayName": "baht thaïlandais",
            "displayName-count-one": "baht thaïlandais",
            "displayName-count-other": "bahts thaïlandais",
            "symbol-alt-narrow": "฿"
          },
          "TJR": {
            "displayName": "rouble tadjik",
            "displayName-count-one": "rouble tadjik",
            "displayName-count-other": "roubles tadjiks"
          },
          "TJS": {
            "displayName": "somoni tadjik",
            "displayName-count-one": "somoni tadjik",
            "displayName-count-other": "somonis tadjiks"
          },
          "TMM": {
            "displayName": "manat turkmène",
            "displayName-count-one": "manat turkmène",
            "displayName-count-other": "manats turkmènes"
          },
          "TMT": {
            "displayName": "nouveau manat turkmène",
            "displayName-count-one": "nouveau manat turkmène",
            "displayName-count-other": "nouveaux manats turkmènes"
          },
          "TND": {
            "displayName": "dinar tunisien",
            "displayName-count-one": "dinar tunisien",
            "displayName-count-other": "dinars tunisiens"
          },
          "TOP": {
            "displayName": "pa’anga tongan",
            "displayName-count-one": "pa’anga tongan",
            "displayName-count-other": "pa’angas tongans",
            "symbol-alt-narrow": "$T"
          },
          "TPE": {
            "displayName": "escudo timorais",
            "displayName-count-one": "escudo timorais",
            "displayName-count-other": "escudos timorais"
          },
          "TRL": {
            "displayName": "livre turque (1844–2005)",
            "displayName-count-one": "livre turque (1844–2005)",
            "displayName-count-other": "livres turques (1844–2005)"
          },
          "TRY": {
            "displayName": "livre turque",
            "displayName-count-one": "livre turque",
            "displayName-count-other": "livres turques",
            "symbol-alt-narrow": "₺",
            "symbol-alt-variant": "LT"
          },
          "TTD": {
            "displayName": "dollar de Trinité-et-Tobago",
            "displayName-count-one": "dollar de Trinité-et-Tobago",
            "displayName-count-other": "dollars de Trinité-et-Tobago",
            "symbol": "$TT",
            "symbol-alt-narrow": "$"
          },
          "TWD": {
            "displayName": "nouveau dollar taïwanais",
            "displayName-count-one": "nouveau dollar taïwanais",
            "displayName-count-other": "nouveaux dollars taïwanais",
            "symbol": "TWD",
            "symbol-alt-narrow": "NT$"
          },
          "TZS": {
            "displayName": "shilling tanzanien",
            "displayName-count-one": "shilling tanzanien",
            "displayName-count-other": "shillings tanzaniens"
          },
          "UAH": {
            "displayName": "hryvnia ukrainienne",
            "displayName-count-one": "hryvnia ukrainienne",
            "displayName-count-other": "hryvnias ukrainiennes",
            "symbol-alt-narrow": "₴"
          },
          "UAK": {
            "displayName": "karbovanetz",
            "displayName-count-one": "karbovanets ukrainien (1992–1996)",
            "displayName-count-other": "karbovanets ukrainiens (1992–1996)"
          },
          "UGS": {
            "displayName": "shilling ougandais (1966–1987)",
            "displayName-count-one": "shilling ougandais (1966–1987)",
            "displayName-count-other": "shillings ougandais (1966–1987)"
          },
          "UGX": {
            "displayName": "shilling ougandais",
            "displayName-count-one": "shilling ougandais",
            "displayName-count-other": "shillings ougandais"
          },
          "USD": {
            "displayName": "dollar des États-Unis",
            "displayName-count-one": "dollar des États-Unis",
            "displayName-count-other": "dollars des États-Unis",
            "symbol": "$US",
            "symbol-alt-narrow": "$"
          },
          "USN": {
            "displayName": "dollar des Etats-Unis (jour suivant)",
            "displayName-count-one": "dollar des États-Unis (jour suivant)",
            "displayName-count-other": "dollars des États-Unis (jour suivant)"
          },
          "USS": {
            "displayName": "dollar des Etats-Unis (jour même)",
            "displayName-count-one": "dollar des États-Unis (jour même)",
            "displayName-count-other": "dollars des États-Unis (jour même)"
          },
          "UYI": {
            "displayName": "peso uruguayen (unités indexées)",
            "displayName-count-one": "peso uruguayen (unités indexées)",
            "displayName-count-other": "pesos uruguayen (unités indexées)"
          },
          "UYP": {
            "displayName": "peso uruguayen (1975–1993)",
            "displayName-count-one": "peso uruguayen (1975–1993)",
            "displayName-count-other": "pesos uruguayens (1975–1993)"
          },
          "UYU": {
            "displayName": "peso uruguayen",
            "displayName-count-one": "peso uruguayen",
            "displayName-count-other": "pesos uruguayens",
            "symbol": "$UY",
            "symbol-alt-narrow": "$"
          },
          "UZS": {
            "displayName": "sum ouzbek",
            "displayName-count-one": "sum ouzbek",
            "displayName-count-other": "sums ouzbeks"
          },
          "VEB": {
            "displayName": "bolivar vénézuélien (1871–2008)"
          },
          "VEF": {
            "displayName": "bolivar vénézuélien (2008–2018)",
            "displayName-count-one": "bolivar vénézuélien (2008–2018)",
            "displayName-count-other": "bolivars vénézuéliens (2008–2018)",
            "symbol-alt-narrow": "Bs"
          },
          "VES": {
            "displayName": "bolivar vénézuélien",
            "displayName-count-one": "bolivar vénézuélien",
            "displayName-count-other": "bolivars vénézuéliens"
          },
          "VND": {
            "displayName": "dông vietnamien",
            "displayName-count-one": "dông vietnamien",
            "displayName-count-other": "dôngs vietnamiens",
            "symbol": "₫",
            "symbol-alt-narrow": "₫"
          },
          "VUV": {
            "displayName": "vatu vanuatuan",
            "displayName-count-one": "vatu vanuatuan",
            "displayName-count-other": "vatus vanuatuans"
          },
          "WST": {
            "displayName": "tala samoan",
            "displayName-count-one": "tala samoan",
            "displayName-count-other": "talas samoans",
            "symbol": "$WS"
          },
          "XAF": {
            "displayName": "franc CFA (BEAC)",
            "displayName-count-one": "franc CFA (BEAC)",
            "displayName-count-other": "francs CFA (BEAC)",
            "symbol": "FCFA"
          },
          "XAG": {
            "displayName": "argent",
            "displayName-count-one": "once troy d’argent",
            "displayName-count-other": "onces troy d’argent"
          },
          "XAU": {
            "displayName": "or",
            "displayName-count-one": "once troy d’or",
            "displayName-count-other": "onces troy d’or"
          },
          "XBA": {
            "displayName": "unité européenne composée",
            "displayName-count-one": "unité composée européenne (EURCO)",
            "displayName-count-other": "unités composées européennes (EURCO)"
          },
          "XBB": {
            "displayName": "unité monétaire européenne",
            "displayName-count-one": "unité monétaire européenne (UME–6)",
            "displayName-count-other": "unités monétaires européennes (UME–6)"
          },
          "XBC": {
            "displayName": "unité de compte européenne (XBC)",
            "displayName-count-one": "unité de compte 9 européenne (UEC–9)",
            "displayName-count-other": "unités de compte 9 européennes (UEC–9)"
          },
          "XBD": {
            "displayName": "unité de compte européenne (XBD)",
            "displayName-count-one": "unité de compte 17 européenne (UEC–17)",
            "displayName-count-other": "unités de compte 17 européennes (UEC–17)"
          },
          "XCD": {
            "displayName": "dollar des Caraïbes orientales",
            "displayName-count-one": "dollar des Caraïbes orientales",
            "displayName-count-other": "dollars des Caraïbes orientales",
            "symbol": "XCD",
            "symbol-alt-narrow": "$"
          },
          "XCG": {
            "displayName": "florin caribéen",
            "displayName-count-one": "florin caribéen",
            "displayName-count-other": "florins caribéens",
            "symbol": "Cg."
          },
          "XDR": {
            "displayName": "droit de tirage spécial",
            "displayName-count-one": "droit de tirage spécial",
            "displayName-count-other": "droits de tirage spéciaux"
          },
          "XEU": {
            "displayName": "unité de compte européenne (ECU)"
          },
          "XFO": {
            "displayName": "franc or",
            "displayName-count-one": "franc or",
            "displayName-count-other": "francs or"
          },
          "XFU": {
            "displayName": "franc UIC",
            "displayName-count-one": "franc UIC",
            "displayName-count-other": "francs UIC"
          },
          "XOF": {
            "displayName": "franc CFA (BCEAO)",
            "displayName-count-one": "franc CFA (BCEAO)",
            "displayName-count-other": "francs CFA (BCEAO)",
            "symbol": "F CFA"
          },
          "XPD": {
            "displayName": "palladium",
            "displayName-count-one": "once troy de palladium",
            "displayName-count-other": "onces troy de palladium"
          },
          "XPF": {
            "displayName": "franc CFP",
            "displayName-count-one": "franc CFP",
            "displayName-count-other": "francs CFP",
            "symbol": "FCFP"
          },
          "XPT": {
            "displayName": "platine",
            "displayName-count-one": "once troy de platine",
            "displayName-count-other": "onces troy de platine"
          },
          "XRE": {
            "displayName": "type de fonds RINET",
            "displayName-count-one": "unité de fonds RINET",
            "displayName-count-other": "unités de fonds RINET"
          },
          "XTS": {
            "displayName": "(devise de test)",
            "displayName-count-one": "(devise de test)",
            "displayName-count-other": "(devises de test)"
          },
          "XXX": {
            "displayName": "devise inconnue ou non valide",
            "displayName-count-one": "devise inconnue",
            "displayName-count-other": "devises inconnues",
            "symbol": "¤"
          },
          "YDD": {
            "displayName": "dinar du Yémen",
            "displayName-count-one": "dinar nord-yéménite",
            "displayName-count-other": "dinars nord-yéménites"
          },
          "YER": {
            "displayName": "riyal yéménite",
            "displayName-count-one": "riyal yéménite",
            "displayName-count-other": "riyals yéménites"
          },
          "YUD": {
            "displayName": "nouveau dinar yougoslave",
            "displayName-count-one": "dinar fort yougoslave (1966–1989)",
            "displayName-count-other": "dinars forts yougoslaves (1966–1989)"
          },
          "YUM": {
            "displayName": "dinar yougoslave Noviy",
            "displayName-count-one": "nouveau dinar yougoslave (1994–2003)",
            "displayName-count-other": "nouveaux dinars yougoslaves (1994–2003)"
          },
          "YUN": {
            "displayName": "dinar yougoslave convertible",
            "displayName-count-one": "dinar convertible yougoslave (1990–1992)",
            "displayName-count-other": "dinars convertibles yougoslaves (1990–1992)"
          },
          "ZAL": {
            "displayName": "rand sud-africain (financier)",
            "displayName-count-one": "rand sud-africain (financier)",
            "displayName-count-other": "rands sud-africains (financiers)"
          },
          "ZAR": {
            "displayName": "rand sud-africain",
            "displayName-count-one": "rand sud-africain",
            "displayName-count-other": "rands sud-africains",
            "symbol-alt-narrow": "R"
          },
          "ZMK": {
            "displayName": "kwacha zambien (1968–2012)",
            "displayName-count-one": "kwacha zambien (1968–2012)",
            "displayName-count-other": "kwachas zambiens (1968–2012)"
          },
          "ZMW": {
            "displayName": "kwacha zambien",
            "displayName-count-one": "kwacha zambien",
            "displayName-count-other": "kwachas zambiens",
            "symbol-alt-narrow": "Kw"
          },
          "ZRN": {
            "displayName": "nouveau zaïre zaïrien",
            "displayName-count-one": "nouveau zaïre zaïrien",
            "displayName-count-other": "nouveaux zaïres zaïriens"
          },
          "ZRZ": {
            "displayName": "zaïre zaïrois",
            "displayName-count-one": "zaïre zaïrois",
            "displayName-count-other": "zaïres zaïrois"
          },
          "ZWD": {
            "displayName": "dollar zimbabwéen",
            "displayName-count-one": "dollar zimbabwéen",
            "displayName-count-other": "dollars zimbabwéens"
          },
          "ZWL": {
            "displayName": "dollar zimbabwéen (2009)",
            "displayName-count-one": "dollar zimbabwéen (2009)",
            "displayName-count-other": "dollars zimbabwéens (2009)"
          },
          "ZWR": {
            "displayName": "dollar zimbabwéen (2008)",
            "displayName-count-one": "dollar zimbabwéen (2008)",
            "displayName-count-other": "dollars zimbabwéens (2008)"
          }
        }
      },
      "dates": {
        "calendars": {
          "islamic": {
            "months": {
              "format": {
                "abbreviated": {
                  "1": "mouh.",
                  "2": "saf.",
                  "3": "rab. aw.",
                  "4": "rab. th.",
                  "5": "joum. oul.",
                  "6": "joum. tha.",
                  "7": "raj.",
                  "8": "chaa.",
                  "9": "ram.",
                  "10": "chaw.",
                  "11": "dhou. q.",
                  "12": "dhou. h."
                },
                "narrow": {
                  "1": "1",
                  "2": "2",
                  "3": "3",
                  "4": "4",
                  "5": "5",
                  "6": "6",
                  "7": "7",
                  "8": "8",
                  "9": "9",
                  "10": "10",
                  "11": "11",
                  "12": "12"
                },
                "wide": {
                  "1": "mouharram",
                  "2": "safar",
                  "3": "rabia al awal",
                  "4": "rabia ath-thani",
                  "5": "joumada al oula",
                  "6": "joumada ath-thania",
                  "7": "rajab",
                  "8": "chaabane",
                  "9": "ramadan",
                  "10": "chawwal",
                  "11": "dhou al qi`da",
                  "12": "dhou al-hijja"
                }
              },
              "stand-alone": {
                "abbreviated": {
                  "1": "mouh.",
                  "2": "saf.",
                  "3": "rab. aw.",
                  "4": "rab. th.",
                  "5": "joum. ou.",
                  "6": "joum. th.",
                  "7": "raj.",
                  "8": "chaa.",
                  "9": "ram.",
                  "10": "chaw.",
                  "11": "dhou. qi.",
                  "12": "dhou. hi."
                },
                "narrow": {
                  "1": "1",
                  "2": "2",
                  "3": "3",
                  "4": "4",
                  "5": "5",
                  "6": "6",
                  "7": "7",
                  "8": "8",
                  "9": "9",
                  "10": "10",
                  "11": "11",
                  "12": "12"
                },
                "wide": {
                  "1": "mouharram",
                  "2": "safar",
                  "3": "rabia al awal",
                  "4": "rabia ath-thani",
                  "5": "joumada al oula",
                  "6": "joumada ath-thania",
                  "7": "rajab",
                  "8": "chaabane",
                  "9": "ramadan",
                  "10": "chawwal",
                  "11": "dhou al qi`da",
                  "12": "dhou al-hijja"
                }
              }
            },
            "days": {
              "format": {
                "abbreviated": {
                  "sun": "dim.",
                  "mon": "lun.",
                  "tue": "mar.",
                  "wed": "mer.",
                  "thu": "jeu.",
                  "fri": "ven.",
                  "sat": "sam."
                },
                "narrow": {
                  "sun": "D",
                  "mon": "L",
                  "tue": "M",
                  "wed": "M",
                  "thu": "J",
                  "fri": "V",
                  "sat": "S"
                },
                "short": {
                  "sun": "di",
                  "mon": "lu",
                  "tue": "ma",
                  "wed": "me",
                  "thu": "je",
                  "fri": "ve",
                  "sat": "sa"
                },
                "wide": {
                  "sun": "dimanche",
                  "mon": "lundi",
                  "tue": "mardi",
                  "wed": "mercredi",
                  "thu": "jeudi",
                  "fri": "vendredi",
                  "sat": "samedi"
                }
              },
              "stand-alone": {
                "abbreviated": {
                  "sun": "dim.",
                  "mon": "lun.",
                  "tue": "mar.",
                  "wed": "mer.",
                  "thu": "jeu.",
                  "fri": "ven.",
                  "sat": "sam."
                },
                "narrow": {
                  "sun": "D",
                  "mon": "L",
                  "tue": "M",
                  "wed": "M",
                  "thu": "J",
                  "fri": "V",
                  "sat": "S"
                },
                "short": {
                  "sun": "di",
                  "mon": "lu",
                  "tue": "ma",
                  "wed": "me",
                  "thu": "je",
                  "fri": "ve",
                  "sat": "sa"
                },
                "wide": {
                  "sun": "dimanche",
                  "mon": "lundi",
                  "tue": "mardi",
                  "wed": "mercredi",
                  "thu": "jeudi",
                  "fri": "vendredi",
                  "sat": "samedi"
                }
              }
            },
            "quarters": {
              "format": {
                "abbreviated": {
                  "1": "T1",
                  "2": "T2",
                  "3": "T3",
                  "4": "T4"
                },
                "narrow": {
                  "1": "1",
                  "2": "2",
                  "3": "3",
                  "4": "4"
                },
                "wide": {
                  "1": "1er trimestre",
                  "2": "2e trimestre",
                  "3": "3e trimestre",
                  "4": "4e trimestre"
                }
              },
              "stand-alone": {
                "abbreviated": {
                  "1": "T1",
                  "2": "T2",
                  "3": "T3",
                  "4": "T4"
                },
                "narrow": {
                  "1": "1",
                  "2": "2",
                  "3": "3",
                  "4": "4"
                },
                "wide": {
                  "1": "1er trimestre",
                  "2": "2e trimestre",
                  "3": "3e trimestre",
                  "4": "4e trimestre"
                }
              }
            },
            "dayPeriods": {
              "format": {
                "abbreviated": {
                  "midnight": "minuit",
                  "am": "AM",
                  "noon": "midi",
                  "pm": "PM",
                  "morning1": "matin",
                  "afternoon1": "après-midi",
                  "evening1": "soir",
                  "night1": "matin"
                },
                "narrow": {
                  "midnight": "minuit",
                  "am": "AM",
                  "noon": "midi",
                  "pm": "PM",
                  "morning1": "mat.",
                  "afternoon1": "ap.m.",
                  "evening1": "soir",
                  "night1": "matin"
                },
                "wide": {
                  "midnight": "minuit",
                  "am": "AM",
                  "noon": "midi",
                  "pm": "PM",
                  "morning1": "du matin",
                  "afternoon1": "de l’après-midi",
                  "evening1": "du soir",
                  "night1": "du matin"
                }
              },
              "stand-alone": {
                "abbreviated": {
                  "midnight": "minuit",
                  "am": "AM",
                  "noon": "midi",
                  "pm": "PM",
                  "morning1": "mat.",
                  "afternoon1": "ap.m.",
                  "evening1": "soir",
                  "night1": "matin"
                },
                "narrow": {
                  "midnight": "minuit",
                  "am": "AM",
                  "noon": "midi",
                  "pm": "PM",
                  "morning1": "mat.",
                  "afternoon1": "ap.m.",
                  "evening1": "soir",
                  "night1": "matin"
                },
                "wide": {
                  "midnight": "minuit",
                  "am": "AM",
                  "noon": "midi",
                  "pm": "PM",
                  "morning1": "matin",
                  "afternoon1": "après-midi",
                  "evening1": "soir",
                  "night1": "matin"
                }
              }
            },
            "eras": {
              "eraNames": {
                "0": "ère de l’Hégire"
              },
              "eraAbbr": {
                "0": "AH"
              },
              "eraNarrow": {
                "0": "H"
              }
            },
            "dateFormats": {
              "full": "EEEE d MMMM y G",
              "long": "d MMMM y G",
              "medium": "d MMM y G",
              "short": "dd/MM/y GGGGG"
            },
            "dateSkeletons": {
              "full": "GyMMMMEEEEd",
              "long": "GyMMMMd",
              "medium": "GyMMMd",
              "short": "GGGGGyMMdd"
            },
            "timeFormats": {
              "full": "HH:mm:ss zzzz",
              "long": "HH:mm:ss z",
              "medium": "HH:mm:ss",
              "short": "HH:mm"
            },
            "timeSkeletons": {
              "full": "HHmmsszzzz",
              "long": "HHmmssz",
              "medium": "HHmmss",
              "short": "HHmm"
            },
            "dateTimeFormats": {
              "full": "{1} {0}",
              "long": "{1} {0}",
              "medium": "{1} {0}",
              "short": "{1} {0}",
              "availableFormats": {
                "Bh": "h B",
                "Bhm": "h:mm B",
                "Bhms": "h:mm:ss B",
                "d": "d",
                "E": "ccc",
                "EBhm": "E h:mm B",
                "EBhms": "E h:mm:ss B",
                "Ed": "E d",
                "Ehm": "E h:mm a",
                "EHm": "E HH:mm",
                "Ehms": "E h:mm:ss a",
                "EHms": "E HH:mm:ss",
                "Gy": "y G",
                "GyMd": "dd/MM/y GGGGG",
                "GyMMM": "MMM y G",
                "GyMMMd": "d MMM y G",
                "GyMMMEd": "E d MMM y G",
                "h": "h a",
                "H": "HH",
                "hm": "h:mm a",
                "Hm": "HH:mm",
                "hms": "h:mm:ss a",
                "Hms": "HH:mm:ss",
                "M": "L",
                "Md": "dd/MM",
                "MEd": "E dd/MM",
                "MMM": "LLL",
                "MMMd": "d MMM",
                "MMMEd": "E d MMM",
                "MMMMd": "d MMMM",
                "ms": "mm:ss",
                "y": "y G",
                "yyyy": "y G",
                "yyyyM": "M/y GGGGG",
                "yyyyMd": "d/M/y GGGGG",
                "yyyyMEd": "E d/M/y GGGGG",
                "yyyyMMM": "MMM y G",
                "yyyyMMMd": "d MMM y G",
                "yyyyMMMEd": "E d MMM y G",
                "yyyyMMMM": "MMMM y G",
                "yyyyQQQ": "QQQ y G",
                "yyyyQQQQ": "QQQQ y G"
              },
              "appendItems": {
                "Day": "{0} ({2}: {1})",
                "Day-Of-Week": "{0} {1}",
                "Era": "{1} {0}",
                "Hour": "{0} ({2}: {1})",
                "Minute": "{0} ({2}: {1})",
                "Month": "{0} ({2}: {1})",
                "Quarter": "{0} ({2}: {1})",
                "Second": "{0} ({2}: {1})",
                "Timezone": "{0} {1}",
                "Week": "{0} ({2}: {1})",
                "Year": "{1} {0}"
              },
              "intervalFormats": {
                "intervalFormatFallback": "{0} – {1}",
                "Bh": {
                  "B": "h B – h B",
                  "h": "h – h B"
                },
                "Bhm": {
                  "B": "h:mm B – h:mm B",
                  "h": "h:mm – h:mm B",
                  "m": "h:mm – h:mm B"
                },
                "d": {
                  "d": "d – d"
                },
                "Gy": {
                  "G": "y G 'à' y G",
                  "y": "y–y G"
                },
                "GyM": {
                  "G": "M/y G 'à' M/y G",
                  "M": "M–M/y G",
                  "y": "M/y 'à' M/y G"
                },
                "GyMd": {
                  "d": "d–d/M/y G",
                  "G": "d/M/y G 'à' d/M/y G",
                  "M": "d/M 'à' d/M/y G",
                  "y": "d/M/y 'à' d/M/y G"
                },
                "GyMEd": {
                  "d": "E d 'à' E d/M/y G",
                  "G": "E d/M/y G 'à' E d/M/y G",
                  "M": "E d/M 'à' E d/M/y G",
                  "y": "E d/M/y 'à' E d/M/y G"
                },
                "GyMMM": {
                  "G": "MMM y G 'à' MMM y G",
                  "M": "MMM 'à' MMM y G",
                  "y": "MMM y 'à' MMM y G"
                },
                "GyMMMd": {
                  "d": "d–d MMM y G",
                  "G": "d MMM y G 'à' d MMM y G",
                  "M": "d MMM 'à' d MMM y G",
                  "y": "d MMM y 'à' d MMM y G"
                },
                "GyMMMEd": {
                  "d": "E d 'à' E d MMM y G",
                  "G": "E d MMM y G 'à' E d MMM y G",
                  "M": "E d MMM 'à' E d MMM y G",
                  "y": "E d MMM y 'à' E d MMM y G"
                },
                "h": {
                  "a": "h a – h a",
                  "h": "h – h a"
                },
                "H": {
                  "H": "HH – HH"
                },
                "hm": {
                  "a": "h:mm a – h:mm a",
                  "h": "h:mm – h:mm a",
                  "m": "h:mm – h:mm a"
                },
                "Hm": {
                  "H": "HH:mm – HH:mm",
                  "m": "HH:mm – HH:mm"
                },
                "hmv": {
                  "a": "h:mm a – h:mm a v",
                  "h": "h:mm – h:mm a v",
                  "m": "h:mm – h:mm a v"
                },
                "Hmv": {
                  "H": "HH:mm – HH:mm v",
                  "m": "HH:mm – HH:mm v"
                },
                "hv": {
                  "a": "h a – h a v",
                  "h": "h – h a v"
                },
                "Hv": {
                  "H": "HH – HH v"
                },
                "M": {
                  "M": "M – M"
                },
                "Md": {
                  "d": "dd/MM – dd/MM",
                  "M": "dd/MM – dd/MM"
                },
                "MEd": {
                  "d": "E dd/MM – E dd/MM",
                  "M": "E dd/MM – E dd/MM"
                },
                "MMM": {
                  "M": "MMM–MMM"
                },
                "MMMd": {
                  "d": "d–d MMM",
                  "M": "d MMM – d MMM"
                },
                "MMMEd": {
                  "d": "E d MMM – E d MMM",
                  "M": "E d MMM – E d MMM"
                },
                "y": {
                  "y": "y – y G"
                },
                "yM": {
                  "M": "MM/y – MM/y G",
                  "y": "M/y – M/y G"
                },
                "yMd": {
                  "d": "d/M/y – d/M/y G",
                  "M": "d/M/y – d/M/y G",
                  "y": "dd/MM/y – dd/MM/y G"
                },
                "yMEd": {
                  "d": "E dd/MM/y – E dd/MM/y G",
                  "M": "E dd/MM/y – E dd/MM/y G",
                  "y": "E dd/MM/y – E dd/MM/y G"
                },
                "yMMM": {
                  "M": "MMM–MMM y G",
                  "y": "MMM y – MMM y G"
                },
                "yMMMd": {
                  "d": "d–d MMM y G",
                  "M": "d MMM – d MMM y G",
                  "y": "d MMM y – d MMM y G"
                },
                "yMMMEd": {
                  "d": "E d – E d MMM y G",
                  "M": "E d MMM – E d MMM y G",
                  "y": "E d MMM y – E d MMM y G"
                },
                "yMMMM": {
                  "M": "MMMM – MMMM y G",
                  "y": "MMMM y – MMMM y G"
                }
              }
            },
            "dateTimeFormats-atTime": {
              "standard": {
                "full": "{1} 'à' {0}",
                "long": "{1} 'à' {0}",
                "medium": "{1} {0}",
                "short": "{1} {0}"
              }
            }
          },
          "gregorian": {
            "months": {
              "format": {
                "abbreviated": {
                  "1": "janv.",
                  "2": "févr.",
                  "3": "mars",
                  "4": "avr.",
                  "5": "mai",
                  "6": "juin",
                  "7": "juil.",
                  "8": "août",
                  "9": "sept.",
                  "10": "oct.",
                  "11": "nov.",
                  "12": "déc."
                },
                "narrow": {
                  "1": "J",
                  "2": "F",
                  "3": "M",
                  "4": "A",
                  "5": "M",
                  "6": "J",
                  "7": "J",
                  "8": "A",
                  "9": "S",
                  "10": "O",
                  "11": "N",
                  "12": "D"
                },
                "wide": {
                  "1": "janvier",
                  "2": "février",
                  "3": "mars",
                  "4": "avril",
                  "5": "mai",
                  "6": "juin",
                  "7": "juillet",
                  "8": "août",
                  "9": "septembre",
                  "10": "octobre",
                  "11": "novembre",
                  "12": "décembre"
                }
              },
              "stand-alone": {
                "abbreviated": {
                  "1": "janv.",
                  "2": "févr.",
                  "3": "mars",
                  "4": "avr.",
                  "5": "mai",
                  "6": "juin",
                  "7": "juil.",
                  "8": "août",
                  "9": "sept.",
                  "10": "oct.",
                  "11": "nov.",
                  "12": "déc."
                },
                "narrow": {
                  "1": "J",
                  "2": "F",
                  "3": "M",
                  "4": "A",
                  "5": "M",
                  "6": "J",
                  "7": "J",
                  "8": "A",
                  "9": "S",
                  "10": "O",
                  "11": "N",
                  "12": "D"
                },
                "wide": {
                  "1": "janvier",
                  "2": "février",
                  "3": "mars",
                  "4": "avril",
                  "5": "mai",
                  "6": "juin",
                  "7": "juillet",
                  "8": "août",
                  "9": "septembre",
                  "10": "octobre",
                  "11": "novembre",
                  "12": "décembre"
                }
              }
            },
            "days": {
              "format": {
                "abbreviated": {
                  "sun": "dim.",
                  "mon": "lun.",
                  "tue": "mar.",
                  "wed": "mer.",
                  "thu": "jeu.",
                  "fri": "ven.",
                  "sat": "sam."
                },
                "narrow": {
                  "sun": "D",
                  "mon": "L",
                  "tue": "M",
                  "wed": "M",
                  "thu": "J",
                  "fri": "V",
                  "sat": "S"
                },
                "short": {
                  "sun": "di",
                  "mon": "lu",
                  "tue": "ma",
                  "wed": "me",
                  "thu": "je",
                  "fri": "ve",
                  "sat": "sa"
                },
                "wide": {
                  "sun": "dimanche",
                  "mon": "lundi",
                  "tue": "mardi",
                  "wed": "mercredi",
                  "thu": "jeudi",
                  "fri": "vendredi",
                  "sat": "samedi"
                }
              },
              "stand-alone": {
                "abbreviated": {
                  "sun": "dim.",
                  "mon": "lun.",
                  "tue": "mar.",
                  "wed": "mer.",
                  "thu": "jeu.",
                  "fri": "ven.",
                  "sat": "sam."
                },
                "narrow": {
                  "sun": "D",
                  "mon": "L",
                  "tue": "M",
                  "wed": "M",
                  "thu": "J",
                  "fri": "V",
                  "sat": "S"
                },
                "short": {
                  "sun": "di",
                  "mon": "lu",
                  "tue": "ma",
                  "wed": "me",
                  "thu": "je",
                  "fri": "ve",
                  "sat": "sa"
                },
                "wide": {
                  "sun": "dimanche",
                  "mon": "lundi",
                  "tue": "mardi",
                  "wed": "mercredi",
                  "thu": "jeudi",
                  "fri": "vendredi",
                  "sat": "samedi"
                }
              }
            },
            "quarters": {
              "format": {
                "abbreviated": {
                  "1": "T1",
                  "2": "T2",
                  "3": "T3",
                  "4": "T4"
                },
                "narrow": {
                  "1": "1",
                  "2": "2",
                  "3": "3",
                  "4": "4"
                },
                "wide": {
                  "1": "1er trimestre",
                  "2": "2e trimestre",
                  "3": "3e trimestre",
                  "4": "4e trimestre"
                }
              },
              "stand-alone": {
                "abbreviated": {
                  "1": "T1",
                  "2": "T2",
                  "3": "T3",
                  "4": "T4"
                },
                "narrow": {
                  "1": "1",
                  "2": "2",
                  "3": "3",
                  "4": "4"
                },
                "wide": {
                  "1": "1er trimestre",
                  "2": "2e trimestre",
                  "3": "3e trimestre",
                  "4": "4e trimestre"
                }
              }
            },
            "dayPeriods": {
              "format": {
                "abbreviated": {
                  "midnight": "minuit",
                  "am": "AM",
                  "noon": "midi",
                  "pm": "PM",
                  "morning1": "matin",
                  "afternoon1": "après-midi",
                  "evening1": "soir",
                  "night1": "matin"
                },
                "narrow": {
                  "midnight": "minuit",
                  "am": "AM",
                  "noon": "midi",
                  "pm": "PM",
                  "morning1": "mat.",
                  "afternoon1": "ap.m.",
                  "evening1": "soir",
                  "night1": "matin"
                },
                "wide": {
                  "midnight": "minuit",
                  "am": "AM",
                  "noon": "midi",
                  "pm": "PM",
                  "morning1": "du matin",
                  "afternoon1": "de l’après-midi",
                  "evening1": "du soir",
                  "night1": "du matin"
                }
              },
              "stand-alone": {
                "abbreviated": {
                  "midnight": "minuit",
                  "am": "AM",
                  "noon": "midi",
                  "pm": "PM",
                  "morning1": "mat.",
                  "afternoon1": "ap.m.",
                  "evening1": "soir",
                  "night1": "matin"
                },
                "narrow": {
                  "midnight": "minuit",
                  "am": "AM",
                  "noon": "midi",
                  "pm": "PM",
                  "morning1": "mat.",
                  "afternoon1": "ap.m.",
                  "evening1": "soir",
                  "night1": "matin"
                },
                "wide": {
                  "midnight": "minuit",
                  "am": "AM",
                  "noon": "midi",
                  "pm": "PM",
                  "morning1": "matin",
                  "afternoon1": "après-midi",
                  "evening1": "soir",
                  "night1": "matin"
                }
              }
            },
            "eras": {
              "eraNames": {
                "0": "avant Jésus-Christ",
                "1": "après Jésus-Christ",
                "0-alt-variant": "avant l’ère commune",
                "1-alt-variant": "de l’ère commune"
              },
              "eraAbbr": {
                "0": "av. J.-C.",
                "1": "ap. J.-C.",
                "0-alt-variant": "AEC",
                "1-alt-variant": "EC"
              },
              "eraNarrow": {
                "0": "av. J.-C.",
                "1": "ap. J.-C.",
                "0-alt-variant": "AEC",
                "1-alt-variant": "EC"
              }
            },
            "dateFormats": {
              "full": "EEEE d MMMM y",
              "long": "d MMMM y",
              "medium": "d MMM y",
              "short": "dd/MM/y"
            },
            "dateSkeletons": {
              "full": "yMMMMEEEEd",
              "long": "yMMMMd",
              "medium": "yMMMd",
              "short": "yMMdd"
            },
            "timeFormats": {
              "full": "HH:mm:ss zzzz",
              "long": "HH:mm:ss z",
              "medium": "HH:mm:ss",
              "short": "HH:mm"
            },
            "timeSkeletons": {
              "full": "HHmmsszzzz",
              "long": "HHmmssz",
              "medium": "HHmmss",
              "short": "HHmm"
            },
            "dateTimeFormats": {
              "full": "{1}, {0}",
              "long": "{1}, {0}",
              "medium": "{1}, {0}",
              "short": "{1} {0}",
              "availableFormats": {
                "Bh": "h B",
                "Bhm": "h:mm B",
                "Bhms": "h:mm:ss B",
                "d": "d",
                "E": "E",
                "EBhm": "E h:mm B",
                "EBhms": "E h:mm:ss B",
                "Ed": "E d",
                "Ehm": "E h:mm a",
                "EHm": "E HH:mm",
                "Ehms": "E h:mm:ss a",
                "EHms": "E HH:mm:ss",
                "Gy": "y G",
                "GyMd": "dd/MM/y GGGGG",
                "GyMMM": "MMM y G",
                "GyMMMd": "d MMM y G",
                "GyMMMEd": "E d MMM y G",
                "h": "h a",
                "H": "HH 'h'",
                "hm": "h:mm a",
                "Hm": "HH:mm",
                "hms": "h:mm:ss a",
                "Hms": "HH:mm:ss",
                "hmsv": "h:mm:ss a v",
                "Hmsv": "HH:mm:ss v",
                "hmv": "h:mm a v",
                "Hmv": "HH:mm v",
                "M": "L",
                "Md": "dd/MM",
                "MEd": "E dd/MM",
                "MMM": "LLL",
                "MMMd": "d MMM",
                "MMMEd": "E d MMM",
                "MMMMd": "d MMMM",
                "MMMMW-count-one": "'semaine' W (MMMM)",
                "MMMMW-count-other": "'semaine' W (MMMM)",
                "ms": "mm:ss",
                "y": "y",
                "yM": "MM/y",
                "yMd": "dd/MM/y",
                "yMEd": "E dd/MM/y",
                "yMMM": "MMM y",
                "yMMMd": "d MMM y",
                "yMMMEd": "E d MMM y",
                "yMMMM": "MMMM y",
                "yQQQ": "QQQ y",
                "yQQQQ": "QQQQ y",
                "yw-count-one": "'semaine' w 'de' Y",
                "yw-count-other": "'semaine' w 'de' Y"
              },
              "appendItems": {
                "Day": "{0} ({2}: {1})",
                "Day-Of-Week": "{0} {1}",
                "Era": "{1} {0}",
                "Hour": "{0} ({2}: {1})",
                "Minute": "{0} ({2}: {1})",
                "Month": "{0} ({2}: {1})",
                "Quarter": "{0} ({2}: {1})",
                "Second": "{0} ({2}: {1})",
                "Timezone": "{0} {1}",
                "Week": "{0} ({2}: {1})",
                "Year": "{1} {0}"
              },
              "intervalFormats": {
                "intervalFormatFallback": "{0} – {1}",
                "Bh": {
                  "B": "h B – h B",
                  "h": "h – h B"
                },
                "Bhm": {
                  "B": "h:mm B – h:mm B",
                  "h": "h:mm – h:mm B",
                  "m": "h:mm – h:mm B"
                },
                "d": {
                  "d": "d–d"
                },
                "Gy": {
                  "G": "y G 'à' y G",
                  "y": "y–y G"
                },
                "GyM": {
                  "G": "MM/y G – MM/y G",
                  "M": "MM–MM/y G",
                  "y": "MM/y – MM/y G"
                },
                "GyMd": {
                  "d": "d–d/MM/y G",
                  "G": "d/MM/y G – d/MM/y G",
                  "M": "d/MM – d/MM/y G",
                  "y": "d/MM/y – d/MM/y G"
                },
                "GyMEd": {
                  "d": "E d – E d/MM/y G",
                  "G": "E d/MM/y G – E d/MM/y G",
                  "M": "E d/MM – E d/MM/y G",
                  "y": "E d/MM/y – E d/MM/y G"
                },
                "GyMMM": {
                  "G": "MMM y G – MMM y G",
                  "M": "MMM – MMM y G",
                  "y": "MMM y – MMM y G"
                },
                "GyMMMd": {
                  "d": "d–d MMM y G",
                  "G": "d MMM y G – d MMM y G",
                  "M": "d MMM – d MMM y G",
                  "y": "d MMM y – d MMM y G"
                },
                "GyMMMEd": {
                  "d": "E d – E d MMM y G",
                  "G": "E d MMM y G – E d MMM y G",
                  "M": "E d MMM – E d MMM y G",
                  "y": "E d MMM y – E d MMM y G"
                },
                "h": {
                  "a": "h a – h a",
                  "h": "h – h a"
                },
                "H": {
                  "H": "HH – HH"
                },
                "hm": {
                  "a": "h:mm a – h:mm a",
                  "h": "h:mm – h:mm a",
                  "m": "h:mm – h:mm a"
                },
                "Hm": {
                  "H": "HH:mm – HH:mm",
                  "m": "HH:mm – HH:mm"
                },
                "hmv": {
                  "a": "h:mm a – h:mm a v",
                  "h": "h:mm – h:mm a v",
                  "m": "h:mm – h:mm a v"
                },
                "Hmv": {
                  "H": "HH:mm – HH:mm v",
                  "m": "HH:mm – HH:mm v"
                },
                "hv": {
                  "a": "h a – h a v",
                  "h": "h – h a v"
                },
                "Hv": {
                  "H": "HH – HH v"
                },
                "M": {
                  "M": "M–M"
                },
                "Md": {
                  "d": "dd/MM – dd/MM",
                  "M": "dd/MM – dd/MM"
                },
                "MEd": {
                  "d": "E dd/MM – E dd/MM",
                  "M": "E dd/MM – E dd/MM"
                },
                "MMM": {
                  "M": "MMM–MMM"
                },
                "MMMd": {
                  "d": "d–d MMM",
                  "M": "d MMM – d MMM"
                },
                "MMMEd": {
                  "d": "E d – E d MMM",
                  "M": "E d MMM – E d MMM"
                },
                "y": {
                  "y": "y–y"
                },
                "yM": {
                  "M": "MM/y – MM/y",
                  "y": "MM/y – MM/y"
                },
                "yMd": {
                  "d": "dd/MM/y – dd/MM/y",
                  "M": "dd/MM/y – dd/MM/y",
                  "y": "dd/MM/y – dd/MM/y"
                },
                "yMEd": {
                  "d": "E dd/MM/y – E dd/MM/y",
                  "M": "E dd/MM/y – E dd/MM/y",
                  "y": "E dd/MM/y – E dd/MM/y"
                },
                "yMMM": {
                  "M": "MMM–MMM y",
                  "y": "MMM y – MMM y"
                },
                "yMMMd": {
                  "d": "d–d MMM y",
                  "M": "d MMM – d MMM y",
                  "y": "d MMM y – d MMM y"
                },
                "yMMMEd": {
                  "d": "E d – E d MMM y",
                  "M": "E d MMM – E d MMM y",
                  "y": "E d MMM y – E d MMM y"
                },
                "yMMMM": {
                  "M": "MMMM – MMMM y",
                  "y": "MMMM y – MMMM y"
                }
              }
            },
            "dateTimeFormats-atTime": {
              "standard": {
                "full": "{1} 'à' {0}",
                "long": "{1} 'à' {0}",
                "medium": "{1}, {0}",
                "short": "{1} {0}"
              }
            }
          }
        },
        "timeZoneNames": {
          "hourFormat": "+HH:mm;−HH:mm",
          "gmtFormat": "UTC{0}",
          "gmtZeroFormat": "UTC",
          "regionFormat": "heure : {0}",
          "regionFormat-type-daylight": "{0} (heure d’été)",
          "regionFormat-type-standard": "{0} (heure standard)",
          "fallbackFormat": "{1} ({0})",
          "zone": {
            "America": {
              "Araguaina": {
                "exemplarCity": "Araguaína"
              },
              "Argentina": {
                "Rio_Gallegos": {
                  "exemplarCity": "Río Gallegos"
                },
                "Ushuaia": {
                  "exemplarCity": "Ushuaïa"
                },
                "Tucuman": {
                  "exemplarCity": "Tucumán"
                }
              },
              "Asuncion": {
                "exemplarCity": "Asunción"
              },
              "Bahia_Banderas": {
                "exemplarCity": "Bahia de Banderas"
              },
              "Barbados": {
                "exemplarCity": "La Barbade"
              },
              "Belem": {
                "exemplarCity": "Belém"
              },
              "Cancun": {
                "exemplarCity": "Cancún"
              },
              "Cayman": {
                "exemplarCity": "Caïmans"
              },
              "Ciudad_Juarez": {
                "exemplarCity": "Ciudad Juárez"
              },
              "Coral_Harbour": {
                "exemplarCity": "Atikokan"
              },
              "Cordoba": {
                "exemplarCity": "Córdoba"
              },
              "Cuiaba": {
                "exemplarCity": "Cuiabá"
              },
              "Curacao": {
                "exemplarCity": "Curaçao"
              },
              "Detroit": {
                "exemplarCity": "Détroit"
              },
              "Dominica": {
                "exemplarCity": "Dominique"
              },
              "Eirunepe": {
                "exemplarCity": "Eirunepé"
              },
              "Godthab": {
                "exemplarCity": "Nuuk"
              },
              "Grenada": {
                "exemplarCity": "Grenade"
              },
              "Havana": {
                "exemplarCity": "La Havane"
              },
              "Indiana": {
                "Vincennes": {
                  "exemplarCity": "Vincennes [Indiana]"
                },
                "Petersburg": {
                  "exemplarCity": "Petersburg [Indiana]"
                },
                "Tell_City": {
                  "exemplarCity": "Tell City [Indiana]"
                },
                "Knox": {
                  "exemplarCity": "Knox [Indiana]"
                },
                "Winamac": {
                  "exemplarCity": "Winamac [Indiana]"
                },
                "Marengo": {
                  "exemplarCity": "Marengo [Indiana]"
                },
                "Vevay": {
                  "exemplarCity": "Vevay [Indiana]"
                }
              },
              "Jamaica": {
                "exemplarCity": "Jamaïque"
              },
              "Kentucky": {
                "Monticello": {
                  "exemplarCity": "Monticello [Kentucky]"
                }
              },
              "Lower_Princes": {
                "exemplarCity": "Lower Prince’s Quarter"
              },
              "Maceio": {
                "exemplarCity": "Maceió"
              },
              "Manaus": {
                "exemplarCity": "Manaos"
              },
              "Mazatlan": {
                "exemplarCity": "Mazatlán"
              },
              "Merida": {
                "exemplarCity": "Mérida"
              },
              "Mexico_City": {
                "exemplarCity": "Mexico"
              },
              "North_Dakota": {
                "Beulah": {
                  "exemplarCity": "Beulah (Dakota du Nord)"
                },
                "New_Salem": {
                  "exemplarCity": "New Salem (Dakota du Nord)"
                },
                "Center": {
                  "exemplarCity": "Center (Dakota du Nord)"
                }
              },
              "Port_of_Spain": {
                "exemplarCity": "Port-d’Espagne"
              },
              "Puerto_Rico": {
                "exemplarCity": "Porto Rico"
              },
              "Santarem": {
                "exemplarCity": "Santarém"
              },
              "Santo_Domingo": {
                "exemplarCity": "Saint-Domingue"
              },
              "Sao_Paulo": {
                "exemplarCity": "São Paulo"
              },
              "Scoresbysund": {
                "exemplarCity": "Ittoqqortoormiit"
              },
              "St_Barthelemy": {
                "exemplarCity": "Saint-Barthélemy"
              },
              "St_Johns": {
                "exemplarCity": "Saint-Jean de Terre-Neuve"
              },
              "St_Kitts": {
                "exemplarCity": "Saint-Christophe"
              },
              "St_Lucia": {
                "exemplarCity": "Sainte-Lucie"
              },
              "St_Thomas": {
                "exemplarCity": "Saint-Thomas"
              },
              "St_Vincent": {
                "exemplarCity": "Saint-Vincent"
              },
              "Thule": {
                "exemplarCity": "Thulé"
              }
            },
            "Atlantic": {
              "Azores": {
                "exemplarCity": "Açores"
              },
              "Bermuda": {
                "exemplarCity": "Bermudes"
              },
              "Canary": {
                "exemplarCity": "Îles Canaries"
              },
              "Cape_Verde": {
                "exemplarCity": "Cap-Vert"
              },
              "Faeroe": {
                "exemplarCity": "Îles Féroé"
              },
              "Madeira": {
                "exemplarCity": "Madère"
              },
              "South_Georgia": {
                "exemplarCity": "Géorgie du Sud"
              },
              "St_Helena": {
                "exemplarCity": "Sainte-Hélène"
              }
            },
            "Europe": {
              "Andorra": {
                "exemplarCity": "Andorre"
              },
              "Athens": {
                "exemplarCity": "Athènes"
              },
              "Brussels": {
                "exemplarCity": "Bruxelles"
              },
              "Bucharest": {
                "exemplarCity": "Bucarest"
              },
              "Busingen": {
                "exemplarCity": "Büsingen"
              },
              "Copenhagen": {
                "exemplarCity": "Copenhague"
              },
              "Dublin": {
                "long": {
                  "daylight": "heure d’été irlandaise"
                }
              },
              "Guernsey": {
                "exemplarCity": "Guernesey"
              },
              "Isle_of_Man": {
                "exemplarCity": "Île de Man"
              },
              "Kiev": {
                "exemplarCity": "Kiev"
              },
              "Lisbon": {
                "exemplarCity": "Lisbonne"
              },
              "London": {
                "long": {
                  "daylight": "heure d’été britannique"
                },
                "exemplarCity": "Londres"
              },
              "Malta": {
                "exemplarCity": "Malte"
              },
              "Moscow": {
                "exemplarCity": "Moscou"
              },
              "San_Marino": {
                "exemplarCity": "Saint-Marin"
              },
              "Tirane": {
                "exemplarCity": "Tirana"
              },
              "Ulyanovsk": {
                "exemplarCity": "Oulianovsk"
              },
              "Vatican": {
                "exemplarCity": "Le Vatican"
              },
              "Vienna": {
                "exemplarCity": "Vienne"
              },
              "Warsaw": {
                "exemplarCity": "Varsovie"
              }
            },
            "Africa": {
              "Addis_Ababa": {
                "exemplarCity": "Addis-Abeba"
              },
              "Algiers": {
                "exemplarCity": "Alger"
              },
              "Asmera": {
                "exemplarCity": "Asmara"
              },
              "Cairo": {
                "exemplarCity": "Le Caire"
              },
              "El_Aaiun": {
                "exemplarCity": "Laâyoune"
              },
              "Lome": {
                "exemplarCity": "Lomé"
              },
              "Mogadishu": {
                "exemplarCity": "Mogadiscio"
              },
              "Ndjamena": {
                "exemplarCity": "N’Djamena"
              },
              "Sao_Tome": {
                "exemplarCity": "São Tomé"
              },
              "Tripoli": {
                "exemplarCity": "Tripoli (Libye)"
              }
            },
            "Asia": {
              "Almaty": {
                "exemplarCity": "Alma Ata"
              },
              "Aqtau": {
                "exemplarCity": "Aktaou"
              },
              "Aqtobe": {
                "exemplarCity": "Aktioubinsk"
              },
              "Ashgabat": {
                "exemplarCity": "Achgabat"
              },
              "Atyrau": {
                "exemplarCity": "Atyraou"
              },
              "Baghdad": {
                "exemplarCity": "Bagdad"
              },
              "Bahrain": {
                "exemplarCity": "Bahreïn"
              },
              "Baku": {
                "exemplarCity": "Bakou"
              },
              "Beirut": {
                "exemplarCity": "Beyrouth"
              },
              "Bishkek": {
                "exemplarCity": "Bichkek"
              },
              "Calcutta": {
                "exemplarCity": "Calcutta"
              },
              "Chita": {
                "exemplarCity": "Tchita"
              },
              "Choibalsan": {
                "exemplarCity": "Tchoïbalsan"
              },
              "Damascus": {
                "exemplarCity": "Damas"
              },
              "Dubai": {
                "exemplarCity": "Dubaï"
              },
              "Dushanbe": {
                "exemplarCity": "Douchanbé"
              },
              "Famagusta": {
                "exemplarCity": "Famagouste"
              },
              "Hebron": {
                "exemplarCity": "Hébron"
              },
              "Irkutsk": {
                "exemplarCity": "Irkoutsk"
              },
              "Jerusalem": {
                "exemplarCity": "Jérusalem"
              },
              "Kabul": {
                "exemplarCity": "Kaboul"
              },
              "Kamchatka": {
                "exemplarCity": "Kamtchatka"
              },
              "Katmandu": {
                "exemplarCity": "Katmandou"
              },
              "Krasnoyarsk": {
                "exemplarCity": "Krasnoïarsk"
              },
              "Kuwait": {
                "exemplarCity": "Koweït"
              },
              "Macau": {
                "exemplarCity": "Macao"
              },
              "Makassar": {
                "exemplarCity": "Macassar"
              },
              "Manila": {
                "exemplarCity": "Manille"
              },
              "Muscat": {
                "exemplarCity": "Mascate"
              },
              "Nicosia": {
                "exemplarCity": "Nicosie"
              },
              "Novosibirsk": {
                "exemplarCity": "Novossibirsk"
              },
              "Oral": {
                "exemplarCity": "Ouralsk"
              },
              "Qostanay": {
                "exemplarCity": "Kostanaï"
              },
              "Qyzylorda": {
                "exemplarCity": "Kzyl Orda"
              },
              "Rangoon": {
                "exemplarCity": "Rangoun"
              },
              "Riyadh": {
                "exemplarCity": "Riyad"
              },
              "Saigon": {
                "exemplarCity": "Hô-Chi-Minh-Ville"
              },
              "Sakhalin": {
                "exemplarCity": "Sakhaline"
              },
              "Samarkand": {
                "exemplarCity": "Samarcande"
              },
              "Seoul": {
                "exemplarCity": "Séoul"
              },
              "Singapore": {
                "exemplarCity": "Singapour"
              },
              "Tashkent": {
                "exemplarCity": "Tachkent"
              },
              "Tbilisi": {
                "exemplarCity": "Tbilissi"
              },
              "Tehran": {
                "exemplarCity": "Téhéran"
              },
              "Ulaanbaatar": {
                "exemplarCity": "Oulan-Bator"
              },
              "Urumqi": {
                "exemplarCity": "Ürümqi"
              },
              "Yakutsk": {
                "exemplarCity": "Iakoutsk"
              },
              "Yekaterinburg": {
                "exemplarCity": "Ekaterinbourg"
              },
              "Yerevan": {
                "exemplarCity": "Erevan"
              }
            },
            "Indian": {
              "Comoro": {
                "exemplarCity": "Comores"
              },
              "Mahe": {
                "exemplarCity": "Mahé"
              },
              "Mauritius": {
                "exemplarCity": "Maurice"
              },
              "Reunion": {
                "exemplarCity": "La Réunion"
              }
            },
            "Australia": {
              "Adelaide": {
                "exemplarCity": "Adélaïde"
              }
            },
            "Pacific": {
              "Easter": {
                "exemplarCity": "Île de Pâques"
              },
              "Efate": {
                "exemplarCity": "Éfaté"
              },
              "Enderbury": {
                "exemplarCity": "Enderbury"
              },
              "Fiji": {
                "exemplarCity": "Fidji"
              },
              "Galapagos": {
                "exemplarCity": "Galápagos"
              },
              "Honolulu": {
                "exemplarCity": "Honolulu"
              },
              "Kanton": {
                "exemplarCity": "Canton"
              },
              "Marquesas": {
                "exemplarCity": "Marquises"
              },
              "Noumea": {
                "exemplarCity": "Nouméa"
              },
              "Palau": {
                "exemplarCity": "Palaos"
              },
              "Ponape": {
                "exemplarCity": "Pohnpei"
              },
              "Truk": {
                "exemplarCity": "Chuuk"
              }
            },
            "Antarctica": {
              "DumontDUrville": {
                "exemplarCity": "Dumont-d’Urville"
              },
              "Syowa": {
                "exemplarCity": "Showa"
              }
            },
            "Etc": {
              "UTC": {
                "long": {
                  "standard": "temps universel coordonné"
                },
                "short": {
                  "standard": "UTC"
                }
              },
              "Unknown": {
                "exemplarCity": "ville inconnue"
              }
            }
          },
          "metazone": {
            "Acre": {
              "long": {
                "generic": "heure de l’Acre",
                "standard": "heure normale de l’Acre",
                "daylight": "heure d’été de l’Acre"
              }
            },
            "Afghanistan": {
              "long": {
                "standard": "heure de l’Afghanistan"
              }
            },
            "Africa_Central": {
              "long": {
                "standard": "heure normale d’Afrique centrale"
              }
            },
            "Africa_Eastern": {
              "long": {
                "standard": "heure normale d’Afrique de l’Est"
              }
            },
            "Africa_Southern": {
              "long": {
                "standard": "heure normale d’Afrique méridionale"
              }
            },
            "Africa_Western": {
              "long": {
                "generic": "heure d’Afrique de l’Ouest",
                "standard": "heure normale d’Afrique de l’Ouest",
                "daylight": "heure d’été d’Afrique de l’Ouest"
              }
            },
            "Alaska": {
              "long": {
                "generic": "heure de l’Alaska",
                "standard": "heure normale de l’Alaska",
                "daylight": "heure d’été de l’Alaska"
              }
            },
            "Almaty": {
              "long": {
                "generic": "heure d’Alma Ata",
                "standard": "heure normale d’Alma Ata",
                "daylight": "heure d’été d’Alma Ata"
              }
            },
            "Amazon": {
              "long": {
                "generic": "heure de l’Amazonie",
                "standard": "heure normale de l’Amazonie",
                "daylight": "heure d’été de l’Amazonie"
              }
            },
            "America_Central": {
              "long": {
                "generic": "heure du centre nord-américain",
                "standard": "heure normale du centre nord-américain",
                "daylight": "heure d’été du centre nord-américain"
              }
            },
            "America_Eastern": {
              "long": {
                "generic": "heure de l’Est nord-américain",
                "standard": "heure normale de l’Est nord-américain",
                "daylight": "heure d’été de l’Est nord-américain"
              }
            },
            "America_Mountain": {
              "long": {
                "generic": "heure des Rocheuses",
                "standard": "heure normale des Rocheuses",
                "daylight": "heure d’été des Rocheuses"
              }
            },
            "America_Pacific": {
              "long": {
                "generic": "heure du Pacifique nord-américain",
                "standard": "heure normale du Pacifique nord-américain",
                "daylight": "heure d’été du Pacifique nord-américain"
              }
            },
            "Anadyr": {
              "long": {
                "generic": "heure d’Anadyr",
                "standard": "heure normale d’Anadyr",
                "daylight": "heure d’été d’Anadyr"
              }
            },
            "Apia": {
              "long": {
                "generic": "heure d’Apia",
                "standard": "heure normale d’Apia",
                "daylight": "heure d’été d’Apia"
              }
            },
            "Aqtau": {
              "long": {
                "generic": "heure d’Aktaou",
                "standard": "heure normale d’Aktaou",
                "daylight": "heure d’été d’Aktaou"
              }
            },
            "Aqtobe": {
              "long": {
                "generic": "heure d’Aqtöbe",
                "standard": "heure normale d’Aqtöbe",
                "daylight": "heure d’été d’Aqtöbe"
              }
            },
            "Arabian": {
              "long": {
                "generic": "heure de l’Arabie",
                "standard": "heure normale de l’Arabie",
                "daylight": "heure d’été de l’Arabie"
              }
            },
            "Argentina": {
              "long": {
                "generic": "heure de l’Argentine",
                "standard": "heure normale d’Argentine",
                "daylight": "heure d’été de l’Argentine"
              }
            },
            "Argentina_Western": {
              "long": {
                "generic": "heure de l’Ouest argentin",
                "standard": "heure normale de l’Ouest argentin",
                "daylight": "heure d’été de l’Ouest argentin"
              }
            },
            "Armenia": {
              "long": {
                "generic": "heure de l’Arménie",
                "standard": "heure normale de l’Arménie",
                "daylight": "heure d’été d’Arménie"
              }
            },
            "Atlantic": {
              "long": {
                "generic": "heure de l’Atlantique",
                "standard": "heure normale de l’Atlantique",
                "daylight": "heure d’été de l’Atlantique"
              }
            },
            "Australia_Central": {
              "long": {
                "generic": "heure du centre de l’Australie",
                "standard": "heure normale du centre de l’Australie",
                "daylight": "heure d’été du centre de l’Australie"
              }
            },
            "Australia_CentralWestern": {
              "long": {
                "generic": "heure du centre-ouest de l’Australie",
                "standard": "heure normale du centre-ouest de l’Australie",
                "daylight": "heure d’été du centre-ouest de l’Australie"
              }
            },
            "Australia_Eastern": {
              "long": {
                "generic": "heure de l’Est de l’Australie",
                "standard": "heure normale de l’Est de l’Australie",
                "daylight": "heure d’été de l’Est de l’Australie"
              }
            },
            "Australia_Western": {
              "long": {
                "generic": "heure de l’Ouest de l’Australie",
                "standard": "heure normale de l’Ouest de l’Australie",
                "daylight": "heure d’été de l’Ouest de l’Australie"
              }
            },
            "Azerbaijan": {
              "long": {
                "generic": "heure de l’Azerbaïdjan",
                "standard": "heure normale de l’Azerbaïdjan",
                "daylight": "heure d’été d’Azerbaïdjan"
              }
            },
            "Azores": {
              "long": {
                "generic": "heure des Açores",
                "standard": "heure normale des Açores",
                "daylight": "heure d’été des Açores"
              }
            },
            "Bangladesh": {
              "long": {
                "generic": "heure du Bangladesh",
                "standard": "heure normale du Bangladesh",
                "daylight": "heure d’été du Bangladesh"
              }
            },
            "Bhutan": {
              "long": {
                "standard": "heure du Bhoutan"
              }
            },
            "Bolivia": {
              "long": {
                "standard": "heure de Bolivie"
              }
            },
            "Brasilia": {
              "long": {
                "generic": "heure de Brasilia",
                "standard": "heure normale de Brasilia",
                "daylight": "heure d’été de Brasilia"
              }
            },
            "Brunei": {
              "long": {
                "standard": "heure du Brunei"
              }
            },
            "Cape_Verde": {
              "long": {
                "generic": "heure du Cap-Vert",
                "standard": "heure normale du Cap-Vert",
                "daylight": "heure d’été du Cap-Vert"
              }
            },
            "Chamorro": {
              "long": {
                "standard": "heure des Chamorro"
              }
            },
            "Chatham": {
              "long": {
                "generic": "heure des îles Chatham",
                "standard": "heure normale des îles Chatham",
                "daylight": "heure d’été des îles Chatham"
              }
            },
            "Chile": {
              "long": {
                "generic": "heure du Chili",
                "standard": "heure normale du Chili",
                "daylight": "heure d’été du Chili"
              }
            },
            "China": {
              "long": {
                "generic": "heure de la Chine",
                "standard": "heure normale de la Chine",
                "daylight": "heure d’été de Chine"
              }
            },
            "Choibalsan": {
              "long": {
                "generic": "heure de Choibalsan",
                "standard": "heure normale de Choibalsan",
                "daylight": "heure d’été de Choibalsan"
              }
            },
            "Christmas": {
              "long": {
                "standard": "heure de l’île Christmas"
              }
            },
            "Cocos": {
              "long": {
                "standard": "heure des îles Cocos"
              }
            },
            "Colombia": {
              "long": {
                "generic": "heure de Colombie",
                "standard": "heure normale de Colombie",
                "daylight": "heure d’été de Colombie"
              }
            },
            "Cook": {
              "long": {
                "generic": "heure des îles Cook",
                "standard": "heure normale des îles Cook",
                "daylight": "heure d’été des îles Cook"
              }
            },
            "Cuba": {
              "long": {
                "generic": "heure de Cuba",
                "standard": "heure normale de Cuba",
                "daylight": "heure d’été de Cuba"
              }
            },
            "Davis": {
              "long": {
                "standard": "heure de Davis"
              }
            },
            "DumontDUrville": {
              "long": {
                "standard": "heure de Dumont-d’Urville"
              }
            },
            "East_Timor": {
              "long": {
                "standard": "heure du Timor oriental"
              }
            },
            "Easter": {
              "long": {
                "generic": "heure de l’île de Pâques",
                "standard": "heure normale de l’île de Pâques",
                "daylight": "heure d’été de l’île de Pâques"
              }
            },
            "Ecuador": {
              "long": {
                "standard": "heure de l’Équateur"
              }
            },
            "Europe_Central": {
              "long": {
                "generic": "heure d’Europe centrale",
                "standard": "heure normale d’Europe centrale",
                "daylight": "heure d’été d’Europe centrale"
              }
            },
            "Europe_Eastern": {
              "long": {
                "generic": "heure d’Europe de l’Est",
                "standard": "heure normale d’Europe de l’Est",
                "daylight": "heure d’été d’Europe de l’Est"
              }
            },
            "Europe_Further_Eastern": {
              "long": {
                "standard": "heure de Kaliningrad"
              }
            },
            "Europe_Western": {
              "long": {
                "generic": "heure d’Europe de l’Ouest",
                "standard": "heure normale d’Europe de l’Ouest",
                "daylight": "heure d’été d’Europe de l’Ouest"
              }
            },
            "Falkland": {
              "long": {
                "generic": "heure des îles Malouines",
                "standard": "heure normale des îles Malouines",
                "daylight": "heure d’été des îles Malouines"
              }
            },
            "Fiji": {
              "long": {
                "generic": "heure des îles Fidji",
                "standard": "heure normale des îles Fidji",
                "daylight": "heure d’été des îles Fidji"
              }
            },
            "French_Guiana": {
              "long": {
                "standard": "heure de la Guyane française"
              }
            },
            "French_Southern": {
              "long": {
                "standard": "heure des Terres australes et antarctiques françaises"
              }
            },
            "Galapagos": {
              "long": {
                "standard": "heure des îles Galápagos"
              }
            },
            "Gambier": {
              "long": {
                "standard": "heure des îles Gambier"
              }
            },
            "Georgia": {
              "long": {
                "generic": "heure de la Géorgie",
                "standard": "heure normale de la Géorgie",
                "daylight": "heure d’été de Géorgie"
              }
            },
            "Gilbert_Islands": {
              "long": {
                "standard": "heure des îles Gilbert"
              }
            },
            "GMT": {
              "long": {
                "standard": "heure moyenne de Greenwich"
              }
            },
            "Greenland_Eastern": {
              "long": {
                "generic": "heure de l’Est du Groenland",
                "standard": "heure normale de l’Est du Groenland",
                "daylight": "heure d’été de l’Est du Groenland"
              }
            },
            "Greenland_Western": {
              "long": {
                "generic": "heure de l’Ouest du Groenland",
                "standard": "heure normale de l’Ouest du Groenland",
                "daylight": "heure d’été de l’Ouest du Groenland"
              }
            },
            "Guam": {
              "long": {
                "standard": "heure de Guam"
              }
            },
            "Gulf": {
              "long": {
                "standard": "heure du Golfe"
              }
            },
            "Guyana": {
              "long": {
                "standard": "heure du Guyana"
              }
            },
            "Hawaii_Aleutian": {
              "long": {
                "generic": "heure d’Hawaï - Aléoutiennes",
                "standard": "heure normale d’Hawaï - Aléoutiennes",
                "daylight": "heure d’été d’Hawaï - Aléoutiennes"
              }
            },
            "Hong_Kong": {
              "long": {
                "generic": "heure de Hong Kong",
                "standard": "heure normale de Hong Kong",
                "daylight": "heure d’été de Hong Kong"
              }
            },
            "Hovd": {
              "long": {
                "generic": "heure de Hovd",
                "standard": "heure normale de Hovd",
                "daylight": "heure d’été de Hovd"
              }
            },
            "India": {
              "long": {
                "standard": "heure de l’Inde"
              }
            },
            "Indian_Ocean": {
              "long": {
                "standard": "heure de l’Océan Indien"
              }
            },
            "Indochina": {
              "long": {
                "standard": "heure d’Indochine"
              }
            },
            "Indonesia_Central": {
              "long": {
                "standard": "heure du Centre indonésien"
              }
            },
            "Indonesia_Eastern": {
              "long": {
                "standard": "heure de l’Est indonésien"
              }
            },
            "Indonesia_Western": {
              "long": {
                "standard": "heure de l’Ouest indonésien"
              }
            },
            "Iran": {
              "long": {
                "generic": "heure de l’Iran",
                "standard": "heure normale d’Iran",
                "daylight": "heure d’été d’Iran"
              }
            },
            "Irkutsk": {
              "long": {
                "generic": "heure d’Irkoutsk",
                "standard": "heure normale d’Irkoutsk",
                "daylight": "heure d’été d’Irkoutsk"
              }
            },
            "Israel": {
              "long": {
                "generic": "heure d’Israël",
                "standard": "heure normale d’Israël",
                "daylight": "heure d’été d’Israël"
              }
            },
            "Japan": {
              "long": {
                "generic": "heure du Japon",
                "standard": "heure normale du Japon",
                "daylight": "heure d’été du Japon"
              }
            },
            "Kamchatka": {
              "long": {
                "generic": "heure de Petropavlovsk-Kamchatski",
                "standard": "heure normale de Petropavlovsk-Kamchatski",
                "daylight": "heure d’été de Petropavlovsk-Kamchatski"
              }
            },
            "Kazakhstan_Eastern": {
              "long": {
                "standard": "heure de l’Est du Kazakhstan"
              }
            },
            "Kazakhstan_Western": {
              "long": {
                "standard": "heure de l’Ouest du Kazakhstan"
              }
            },
            "Korea": {
              "long": {
                "generic": "heure de la Corée",
                "standard": "heure normale de la Corée",
                "daylight": "heure d’été de Corée"
              }
            },
            "Kosrae": {
              "long": {
                "standard": "heure de Kosrae"
              }
            },
            "Krasnoyarsk": {
              "long": {
                "generic": "heure de Krasnoïarsk",
                "standard": "heure normale de Krasnoïarsk",
                "daylight": "heure d’été de Krasnoïarsk"
              }
            },
            "Kyrgystan": {
              "long": {
                "standard": "heure du Kirghizistan"
              }
            },
            "Line_Islands": {
              "long": {
                "standard": "heure des îles de la Ligne"
              }
            },
            "Lord_Howe": {
              "long": {
                "generic": "heure de Lord Howe",
                "standard": "heure normale de Lord Howe",
                "daylight": "heure d’été de Lord Howe"
              }
            },
            "Magadan": {
              "long": {
                "generic": "heure de Magadan",
                "standard": "heure normale de Magadan",
                "daylight": "heure d’été de Magadan"
              }
            },
            "Malaysia": {
              "long": {
                "standard": "heure de la Malaisie"
              }
            },
            "Maldives": {
              "long": {
                "standard": "heure des Maldives"
              }
            },
            "Marquesas": {
              "long": {
                "standard": "heure des îles Marquises"
              }
            },
            "Marshall_Islands": {
              "long": {
                "standard": "heure des îles Marshall"
              }
            },
            "Mauritius": {
              "long": {
                "generic": "heure de Maurice",
                "standard": "heure normale de Maurice",
                "daylight": "heure d’été de Maurice"
              }
            },
            "Mawson": {
              "long": {
                "standard": "heure de Mawson"
              }
            },
            "Mexico_Pacific": {
              "long": {
                "generic": "heure du Pacifique mexicain",
                "standard": "heure normale du Pacifique mexicain",
                "daylight": "heure d’été du Pacifique mexicain"
              }
            },
            "Mongolia": {
              "long": {
                "generic": "heure d’Oulan-Bator",
                "standard": "heure normale d’Oulan-Bator",
                "daylight": "heure d’été d’Oulan-Bator"
              }
            },
            "Moscow": {
              "long": {
                "generic": "heure de Moscou",
                "standard": "heure normale de Moscou",
                "daylight": "heure d’été de Moscou"
              }
            },
            "Myanmar": {
              "long": {
                "standard": "heure du Myanmar"
              }
            },
            "Nauru": {
              "long": {
                "standard": "heure de Nauru"
              }
            },
            "Nepal": {
              "long": {
                "standard": "heure du Népal"
              }
            },
            "New_Caledonia": {
              "long": {
                "generic": "heure de la Nouvelle-Calédonie",
                "standard": "heure normale de la Nouvelle-Calédonie",
                "daylight": "heure d’été de Nouvelle-Calédonie"
              }
            },
            "New_Zealand": {
              "long": {
                "generic": "heure de la Nouvelle-Zélande",
                "standard": "heure normale de la Nouvelle-Zélande",
                "daylight": "heure d’été de la Nouvelle-Zélande"
              }
            },
            "Newfoundland": {
              "long": {
                "generic": "heure de Terre-Neuve",
                "standard": "heure normale de Terre-Neuve",
                "daylight": "heure d’été de Terre-Neuve"
              }
            },
            "Niue": {
              "long": {
                "standard": "heure de Niue"
              }
            },
            "Norfolk": {
              "long": {
                "generic": "heure de l’île Norfolk",
                "standard": "heure normale de l’île Norfolk",
                "daylight": "heure d’été de l’île Norfolk"
              }
            },
            "Noronha": {
              "long": {
                "generic": "heure de Fernando de Noronha",
                "standard": "heure normale de Fernando de Noronha",
                "daylight": "heure d’été de Fernando de Noronha"
              }
            },
            "North_Mariana": {
              "long": {
                "standard": "heure des îles Mariannes du Nord"
              }
            },
            "Novosibirsk": {
              "long": {
                "generic": "heure de Novossibirsk",
                "standard": "heure normale de Novossibirsk",
                "daylight": "heure d’été de Novossibirsk"
              }
            },
            "Omsk": {
              "long": {
                "generic": "heure de Omsk",
                "standard": "heure normale de Omsk",
                "daylight": "heure d’été de Omsk"
              }
            },
            "Pakistan": {
              "long": {
                "generic": "heure du Pakistan",
                "standard": "heure normale du Pakistan",
                "daylight": "heure d’été du Pakistan"
              }
            },
            "Palau": {
              "long": {
                "standard": "heure des Palaos"
              }
            },
            "Papua_New_Guinea": {
              "long": {
                "standard": "heure de la Papouasie-Nouvelle-Guinée"
              }
            },
            "Paraguay": {
              "long": {
                "generic": "heure du Paraguay",
                "standard": "heure normale du Paraguay",
                "daylight": "heure d’été du Paraguay"
              }
            },
            "Peru": {
              "long": {
                "generic": "heure du Pérou",
                "standard": "heure normale du Pérou",
                "daylight": "heure d’été du Pérou"
              }
            },
            "Philippines": {
              "long": {
                "generic": "heure des Philippines",
                "standard": "heure normale des Philippines",
                "daylight": "heure d’été des Philippines"
              }
            },
            "Phoenix_Islands": {
              "long": {
                "standard": "heure des îles Phoenix"
              }
            },
            "Pierre_Miquelon": {
              "long": {
                "generic": "heure de Saint-Pierre-et-Miquelon",
                "standard": "heure normale de Saint-Pierre-et-Miquelon",
                "daylight": "heure d’été de Saint-Pierre-et-Miquelon"
              }
            },
            "Pitcairn": {
              "long": {
                "standard": "heure des îles Pitcairn"
              }
            },
            "Ponape": {
              "long": {
                "standard": "heure de l’île de Pohnpei"
              }
            },
            "Pyongyang": {
              "long": {
                "standard": "heure de Pyongyang"
              }
            },
            "Reunion": {
              "long": {
                "standard": "heure de La Réunion"
              }
            },
            "Rothera": {
              "long": {
                "standard": "heure de Rothera"
              }
            },
            "Sakhalin": {
              "long": {
                "generic": "heure de Sakhaline",
                "standard": "heure normale de Sakhaline",
                "daylight": "heure d’été de Sakhaline"
              }
            },
            "Samara": {
              "long": {
                "generic": "heure de Samara",
                "standard": "heure normale de Samara",
                "daylight": "heure d’été de Samara"
              }
            },
            "Samoa": {
              "long": {
                "generic": "heure des Samoa",
                "standard": "heure normale des Samoa",
                "daylight": "heure d’été des Samoa"
              }
            },
            "Seychelles": {
              "long": {
                "standard": "heure des Seychelles"
              }
            },
            "Singapore": {
              "long": {
                "standard": "heure de Singapour"
              }
            },
            "Solomon": {
              "long": {
                "standard": "heure des îles Salomon"
              }
            },
            "South_Georgia": {
              "long": {
                "standard": "heure de Géorgie du Sud"
              }
            },
            "Suriname": {
              "long": {
                "standard": "heure du Suriname"
              }
            },
            "Syowa": {
              "long": {
                "standard": "heure de Syowa"
              }
            },
            "Tahiti": {
              "long": {
                "standard": "heure de Tahiti"
              }
            },
            "Taipei": {
              "long": {
                "generic": "heure de Taipei",
                "standard": "heure normale de Taipei",
                "daylight": "heure d’été de Taipei"
              }
            },
            "Tajikistan": {
              "long": {
                "standard": "heure du Tadjikistan"
              }
            },
            "Tokelau": {
              "long": {
                "standard": "heure de Tokelau"
              }
            },
            "Tonga": {
              "long": {
                "generic": "heure des Tonga",
                "standard": "heure normale des Tonga",
                "daylight": "heure d’été de Tonga"
              }
            },
            "Truk": {
              "long": {
                "standard": "heure de Chuuk"
              }
            },
            "Turkmenistan": {
              "long": {
                "generic": "heure du Turkménistan",
                "standard": "heure normale du Turkménistan",
                "daylight": "heure d’été du Turkménistan"
              }
            },
            "Tuvalu": {
              "long": {
                "standard": "heure des Tuvalu"
              }
            },
            "Uruguay": {
              "long": {
                "generic": "heure de l’Uruguay",
                "standard": "heure normale de l’Uruguay",
                "daylight": "heure d’été de l’Uruguay"
              }
            },
            "Uzbekistan": {
              "long": {
                "generic": "heure de l’Ouzbékistan",
                "standard": "heure normale de l’Ouzbékistan",
                "daylight": "heure d’été de l’Ouzbékistan"
              }
            },
            "Vanuatu": {
              "long": {
                "generic": "heure du Vanuatu",
                "standard": "heure normale du Vanuatu",
                "daylight": "heure d’été de Vanuatu"
              }
            },
            "Venezuela": {
              "long": {
                "standard": "heure du Venezuela"
              }
            },
            "Vladivostok": {
              "long": {
                "generic": "heure de Vladivostok",
                "standard": "heure normale de Vladivostok",
                "daylight": "heure d’été de Vladivostok"
              }
            },
            "Volgograd": {
              "long": {
                "generic": "heure de Volgograd",
                "standard": "heure normale de Volgograd",
                "daylight": "heure d’été de Volgograd"
              }
            },
            "Vostok": {
              "long": {
                "standard": "heure de Vostok"
              }
            },
            "Wake": {
              "long": {
                "standard": "heure de l’île Wake"
              }
            },
            "Wallis": {
              "long": {
                "standard": "heure de Wallis-et-Futuna"
              }
            },
            "Yakutsk": {
              "long": {
                "generic": "heure de Iakoutsk",
                "standard": "heure normale de Iakoutsk",
                "daylight": "heure d’été de Iakoutsk"
              }
            },
            "Yekaterinburg": {
              "long": {
                "generic": "heure d’Ekaterinbourg",
                "standard": "heure normale d’Ekaterinbourg",
                "daylight": "heure d’été d’Ekaterinbourg"
              }
            },
            "Yukon": {
              "long": {
                "standard": "heure normale du Yukon"
              }
            }
          }
        }
      }
    }
  }
}